var Cs = Object.defineProperty;
var qs = (r, t, e) => t in r ? Cs(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var Vt = (r, t, e) => (qs(r, typeof t != "symbol" ? t + "" : t, e), e);
import { fromCodePoint as Se, StateField as Os, RangeSetBuilder as Te, Facet as Mt, EditorState as se, StateEffect as Es, Prec as ms } from "@codemirror/state";
import { ViewPlugin as Ht, EditorView as ht, Decoration as K, hoverTooltip as As, WidgetType as Gs, Direction as Nt, logException as Ns } from "@codemirror/view";
const Ss = 1024;
let Bs = 0;
class ie {
  constructor(t, e) {
    this.from = t, this.to = e;
  }
}
class x {
  /**
  Create a new node prop type.
  */
  constructor(t = {}) {
    this.id = Bs++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(t) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof t != "function" && (t = W.match(t)), (e) => {
      let s = t(e);
      return s === void 0 ? null : [this, s];
    };
  }
}
x.closedBy = new x({ deserialize: (r) => r.split(" ") });
x.openedBy = new x({ deserialize: (r) => r.split(" ") });
x.group = new x({ deserialize: (r) => r.split(" ") });
x.isolate = new x({ deserialize: (r) => {
  if (r && r != "rtl" && r != "ltr" && r != "auto")
    throw new RangeError("Invalid value for isolate: " + r);
  return r || "auto";
} });
x.contextHash = new x({ perNode: !0 });
x.lookAhead = new x({ perNode: !0 });
x.mounted = new x({ perNode: !0 });
class Bt {
  constructor(t, e, s) {
    this.tree = t, this.overlay = e, this.parser = s;
  }
  /**
  @internal
  */
  static get(t) {
    return t && t.props && t.props[x.mounted.id];
  }
}
const Xs = /* @__PURE__ */ Object.create(null);
class W {
  /**
  @internal
  */
  constructor(t, e, s, i = 0) {
    this.name = t, this.props = e, this.id = s, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(t) {
    let e = t.props && t.props.length ? /* @__PURE__ */ Object.create(null) : Xs, s = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), i = new W(t.name || "", e, t.id, s);
    if (t.props) {
      for (let n of t.props)
        if (Array.isArray(n) || (n = n(i)), n) {
          if (n[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          e[n[0].id] = n[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(t) {
    return this.props[t.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(t) {
    if (typeof t == "string") {
      if (this.name == t)
        return !0;
      let e = this.prop(x.group);
      return e ? e.indexOf(t) > -1 : !1;
    }
    return this.id == t;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(t) {
    let e = /* @__PURE__ */ Object.create(null);
    for (let s in t)
      for (let i of s.split(" "))
        e[i] = t[s];
    return (s) => {
      for (let i = s.prop(x.group), n = -1; n < (i ? i.length : 0); n++) {
        let o = e[n < 0 ? s.name : i[n]];
        if (o)
          return o;
      }
    };
  }
}
W.none = new W(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class Fe {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(t) {
    this.types = t;
    for (let e = 0; e < t.length; e++)
      if (t[e].id != e)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...t) {
    let e = [];
    for (let s of this.types) {
      let i = null;
      for (let n of t) {
        let o = n(s);
        o && (i || (i = Object.assign({}, s.props)), i[o[0].id] = o[1]);
      }
      e.push(i ? new W(s.name, i, s.id, s.flags) : s);
    }
    return new Fe(e);
  }
}
const vt = /* @__PURE__ */ new WeakMap(), Pe = /* @__PURE__ */ new WeakMap();
var v;
(function(r) {
  r[r.ExcludeBuffers = 1] = "ExcludeBuffers", r[r.IncludeAnonymous = 2] = "IncludeAnonymous", r[r.IgnoreMounts = 4] = "IgnoreMounts", r[r.IgnoreOverlays = 8] = "IgnoreOverlays";
})(v || (v = {}));
class V {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(t, e, s, i, n) {
    if (this.type = t, this.children = e, this.positions = s, this.length = i, this.props = null, n && n.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [o, l] of n)
        this.props[typeof o == "number" ? o : o.id] = l;
    }
  }
  /**
  @internal
  */
  toString() {
    let t = Bt.get(this);
    if (t && !t.overlay)
      return t.tree.toString();
    let e = "";
    for (let s of this.children) {
      let i = s.toString();
      i && (e && (e += ","), e += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (e.length ? "(" + e + ")" : "") : e;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(t = 0) {
    return new xe(this.topNode, t);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(t, e = 0, s = 0) {
    let i = vt.get(this) || this.topNode, n = new xe(i);
    return n.moveTo(t, e), vt.set(this, n._tree), n;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new E(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(t, e = 0) {
    let s = Tt(vt.get(this) || this.topNode, t, e, !1);
    return vt.set(this, s), s;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(t, e = 0) {
    let s = Tt(Pe.get(this) || this.topNode, t, e, !0);
    return Pe.set(this, s), s;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(t, e = 0) {
    return Qs(this, t, e);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(t) {
    let { enter: e, leave: s, from: i = 0, to: n = this.length } = t, o = t.mode || 0, l = (o & v.IncludeAnonymous) > 0;
    for (let a = this.cursor(o | v.IncludeAnonymous); ; ) {
      let h = !1;
      if (a.from <= n && a.to >= i && (!l && a.type.isAnonymous || e(a) !== !1)) {
        if (a.firstChild())
          continue;
        h = !0;
      }
      for (; h && s && (l || !a.type.isAnonymous) && s(a), !a.nextSibling(); ) {
        if (!a.parent())
          return;
        h = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(t) {
    return t.perNode ? this.props ? this.props[t.id] : void 0 : this.type.prop(t);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let t = [];
    if (this.props)
      for (let e in this.props)
        t.push([+e, this.props[e]]);
    return t;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(t = {}) {
    return this.children.length <= 8 ? this : ve(W.none, this.children, this.positions, 0, this.children.length, 0, this.length, (e, s, i) => new V(this.type, e, s, i, this.propValues), t.makeTree || ((e, s, i) => new V(W.none, e, s, i)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(t) {
    return Ks(t);
  }
}
V.empty = new V(W.none, [], [], 0);
class Re {
  constructor(t, e) {
    this.buffer = t, this.index = e;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new Re(this.buffer, this.index);
  }
}
class st {
  /**
  Create a tree buffer.
  */
  constructor(t, e, s) {
    this.buffer = t, this.length = e, this.set = s;
  }
  /**
  @internal
  */
  get type() {
    return W.none;
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    for (let e = 0; e < this.buffer.length; )
      t.push(this.childString(e)), e = this.buffer[e + 3];
    return t.join(",");
  }
  /**
  @internal
  */
  childString(t) {
    let e = this.buffer[t], s = this.buffer[t + 3], i = this.set.types[e], n = i.name;
    if (/\W/.test(n) && !i.isError && (n = JSON.stringify(n)), t += 4, s == t)
      return n;
    let o = [];
    for (; t < s; )
      o.push(this.childString(t)), t = this.buffer[t + 3];
    return n + "(" + o.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(t, e, s, i, n) {
    let { buffer: o } = this, l = -1;
    for (let a = t; a != e && !(bs(n, i, o[a + 1], o[a + 2]) && (l = a, s > 0)); a = o[a + 3])
      ;
    return l;
  }
  /**
  @internal
  */
  slice(t, e, s) {
    let i = this.buffer, n = new Uint16Array(e - t), o = 0;
    for (let l = t, a = 0; l < e; ) {
      n[a++] = i[l++], n[a++] = i[l++] - s;
      let h = n[a++] = i[l++] - s;
      n[a++] = i[l++] - t, o = Math.max(o, h);
    }
    return new st(n, o, this.set);
  }
}
function bs(r, t, e, s) {
  switch (r) {
    case -2:
      return e < t;
    case -1:
      return s >= t && e < t;
    case 0:
      return e < t && s > t;
    case 1:
      return e <= t && s > t;
    case 2:
      return s > t;
    case 4:
      return !0;
  }
}
function Tt(r, t, e, s) {
  for (var i; r.from == r.to || (e < 1 ? r.from >= t : r.from > t) || (e > -1 ? r.to <= t : r.to < t); ) {
    let o = !s && r instanceof E && r.index < 0 ? null : r.parent;
    if (!o)
      return r;
    r = o;
  }
  let n = s ? 0 : v.IgnoreOverlays;
  if (s)
    for (let o = r, l = o.parent; l; o = l, l = o.parent)
      o instanceof E && o.index < 0 && ((i = l.enter(t, e, n)) === null || i === void 0 ? void 0 : i.from) != o.from && (r = l);
  for (; ; ) {
    let o = r.enter(t, e, n);
    if (!o)
      return r;
    r = o;
  }
}
class xs {
  cursor(t = 0) {
    return new xe(this, t);
  }
  getChild(t, e = null, s = null) {
    let i = Ce(this, t, e, s);
    return i.length ? i[0] : null;
  }
  getChildren(t, e = null, s = null) {
    return Ce(this, t, e, s);
  }
  resolve(t, e = 0) {
    return Tt(this, t, e, !1);
  }
  resolveInner(t, e = 0) {
    return Tt(this, t, e, !0);
  }
  matchContext(t) {
    return be(this, t);
  }
  enterUnfinishedNodesBefore(t) {
    let e = this.childBefore(t), s = this;
    for (; e; ) {
      let i = e.lastChild;
      if (!i || i.to != e.to)
        break;
      i.type.isError && i.from == i.to ? (s = e, e = i.prevSibling) : e = i;
    }
    return s;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class E extends xs {
  constructor(t, e, s, i) {
    super(), this._tree = t, this.from = e, this.index = s, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(t, e, s, i, n = 0) {
    for (let o = this; ; ) {
      for (let { children: l, positions: a } = o._tree, h = e > 0 ? l.length : -1; t != h; t += e) {
        let u = l[t], $ = a[t] + o.from;
        if (bs(i, s, $, $ + u.length)) {
          if (u instanceof st) {
            if (n & v.ExcludeBuffers)
              continue;
            let f = u.findChild(0, u.buffer.length, e, s - $, i);
            if (f > -1)
              return new et(new _s(o, u, t, $), null, f);
          } else if (n & v.IncludeAnonymous || !u.type.isAnonymous || Ve(u)) {
            let f;
            if (!(n & v.IgnoreMounts) && (f = Bt.get(u)) && !f.overlay)
              return new E(f.tree, $, t, o);
            let c = new E(u, $, t, o);
            return n & v.IncludeAnonymous || !c.type.isAnonymous ? c : c.nextChild(e < 0 ? u.children.length - 1 : 0, e, s, i);
          }
        }
      }
      if (n & v.IncludeAnonymous || !o.type.isAnonymous || (o.index >= 0 ? t = o.index + e : t = e < 0 ? -1 : o._parent._tree.children.length, o = o._parent, !o))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(t) {
    return this.nextChild(
      0,
      1,
      t,
      2
      /* Side.After */
    );
  }
  childBefore(t) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  enter(t, e, s = 0) {
    let i;
    if (!(s & v.IgnoreOverlays) && (i = Bt.get(this._tree)) && i.overlay) {
      let n = t - this.from;
      for (let { from: o, to: l } of i.overlay)
        if ((e > 0 ? o <= n : o < n) && (e < 0 ? l >= n : l > n))
          return new E(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, t, e, s);
  }
  nextSignificantParent() {
    let t = this;
    for (; t.type.isAnonymous && t._parent; )
      t = t._parent;
    return t;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function Ce(r, t, e, s) {
  let i = r.cursor(), n = [];
  if (!i.firstChild())
    return n;
  if (e != null) {
    for (; !i.type.is(e); )
      if (!i.nextSibling())
        return n;
  }
  for (; ; ) {
    if (s != null && i.type.is(s))
      return n;
    if (i.type.is(t) && n.push(i.node), !i.nextSibling())
      return s == null ? n : [];
  }
}
function be(r, t, e = t.length - 1) {
  for (let s = r.parent; e >= 0; s = s.parent) {
    if (!s)
      return !1;
    if (!s.type.isAnonymous) {
      if (t[e] && t[e] != s.name)
        return !1;
      e--;
    }
  }
  return !0;
}
class _s {
  constructor(t, e, s, i) {
    this.parent = t, this.buffer = e, this.index = s, this.start = i;
  }
}
class et extends xs {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(t, e, s) {
    super(), this.context = t, this._parent = e, this.index = s, this.type = t.buffer.set.types[t.buffer.buffer[s]];
  }
  child(t, e, s) {
    let { buffer: i } = this.context, n = i.findChild(this.index + 4, i.buffer[this.index + 3], t, e - this.context.start, s);
    return n < 0 ? null : new et(this.context, this, n);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(t) {
    return this.child(
      1,
      t,
      2
      /* Side.After */
    );
  }
  childBefore(t) {
    return this.child(
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  enter(t, e, s = 0) {
    if (s & v.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, n = i.findChild(this.index + 4, i.buffer[this.index + 3], e > 0 ? 1 : -1, t - this.context.start, e);
    return n < 0 ? null : new et(this.context, this, n);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(t) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + t,
      t,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: t } = this.context, e = t.buffer[this.index + 3];
    return e < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new et(this.context, this._parent, e) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: t } = this.context, e = this._parent ? this._parent.index + 4 : 0;
    return this.index == e ? this.externalSibling(-1) : new et(this.context, this._parent, t.findChild(
      e,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let t = [], e = [], { buffer: s } = this.context, i = this.index + 4, n = s.buffer[this.index + 3];
    if (n > i) {
      let o = s.buffer[this.index + 1];
      t.push(s.slice(i, n, o)), e.push(0);
    }
    return new V(this.type, t, e, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function ks(r) {
  if (!r.length)
    return null;
  let t = 0, e = r[0];
  for (let n = 1; n < r.length; n++) {
    let o = r[n];
    (o.from > e.from || o.to < e.to) && (e = o, t = n);
  }
  let s = e instanceof E && e.index < 0 ? null : e.parent, i = r.slice();
  return s ? i[t] = s : i.splice(t, 1), new Ys(i, e);
}
class Ys {
  constructor(t, e) {
    this.heads = t, this.node = e;
  }
  get next() {
    return ks(this.heads);
  }
}
function Qs(r, t, e) {
  let s = r.resolveInner(t, e), i = null;
  for (let n = s instanceof E ? s : s.context.parent; n; n = n.parent)
    if (n.index < 0) {
      let o = n.parent;
      (i || (i = [s])).push(o.resolve(t, e)), n = o;
    } else {
      let o = Bt.get(n.tree);
      if (o && o.overlay && o.overlay[0].from <= t && o.overlay[o.overlay.length - 1].to >= t) {
        let l = new E(o.tree, o.overlay[0].from + n.from, -1, n);
        (i || (i = [s])).push(Tt(l, t, e, !1));
      }
    }
  return i ? ks(i) : s;
}
class xe {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(t, e = 0) {
    if (this.mode = e, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof E)
      this.yieldNode(t);
    else {
      this._tree = t.context.parent, this.buffer = t.context;
      for (let s = t._parent; s; s = s._parent)
        this.stack.unshift(s.index);
      this.bufferNode = t, this.yieldBuf(t.index);
    }
  }
  yieldNode(t) {
    return t ? (this._tree = t, this.type = t.type, this.from = t.from, this.to = t.to, !0) : !1;
  }
  yieldBuf(t, e) {
    this.index = t;
    let { start: s, buffer: i } = this.buffer;
    return this.type = e || i.set.types[i.buffer[t]], this.from = s + i.buffer[t + 1], this.to = s + i.buffer[t + 2], !0;
  }
  /**
  @internal
  */
  yield(t) {
    return t ? t instanceof E ? (this.buffer = null, this.yieldNode(t)) : (this.buffer = t.context, this.yieldBuf(t.index, t.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(t, e, s) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(t < 0 ? this._tree._tree.children.length - 1 : 0, t, e, s, this.mode));
    let { buffer: i } = this.buffer, n = i.findChild(this.index + 4, i.buffer[this.index + 3], t, e - this.buffer.start, s);
    return n < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(n));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(t) {
    return this.enterChild(
      1,
      t,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(t) {
    return this.enterChild(
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(t, e, s = this.mode) {
    return this.buffer ? s & v.ExcludeBuffers ? !1 : this.enterChild(1, t, e) : this.yield(this._tree.enter(t, e, s));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & v.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let t = this.mode & v.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(t);
  }
  /**
  @internal
  */
  sibling(t) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + t, t, 0, 4, this.mode)) : !1;
    let { buffer: e } = this.buffer, s = this.stack.length - 1;
    if (t < 0) {
      let i = s < 0 ? 0 : this.stack[s] + 4;
      if (this.index != i)
        return this.yieldBuf(e.findChild(
          i,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let i = e.buffer[this.index + 3];
      if (i < (s < 0 ? e.buffer.length : e.buffer[this.stack[s] + 3]))
        return this.yieldBuf(i);
    }
    return s < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + t, t, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(t) {
    let e, s, { buffer: i } = this;
    if (i) {
      if (t > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (let n = 0; n < this.index; n++)
          if (i.buffer.buffer[n + 3] < this.index)
            return !1;
      ({ index: e, parent: s } = i);
    } else
      ({ index: e, _parent: s } = this._tree);
    for (; s; { index: e, _parent: s } = s)
      if (e > -1)
        for (let n = e + t, o = t < 0 ? -1 : s._tree.children.length; n != o; n += t) {
          let l = s._tree.children[n];
          if (this.mode & v.IncludeAnonymous || l instanceof st || !l.type.isAnonymous || Ve(l))
            return !1;
        }
    return !0;
  }
  move(t, e) {
    if (e && this.enterChild(
      t,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(t))
        return !0;
      if (this.atLastNode(t) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(t = !0) {
    return this.move(1, t);
  }
  /**
  Move to the next node in a last-to-first pre-order traveral. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(t = !0) {
    return this.move(-1, t);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(t, e = 0) {
    for (; (this.from == this.to || (e < 1 ? this.from >= t : this.from > t) || (e > -1 ? this.to <= t : this.to < t)) && this.parent(); )
      ;
    for (; this.enterChild(1, t, e); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let t = this.bufferNode, e = null, s = 0;
    if (t && t.context == this.buffer)
      t:
        for (let i = this.index, n = this.stack.length; n >= 0; ) {
          for (let o = t; o; o = o._parent)
            if (o.index == i) {
              if (i == this.index)
                return o;
              e = o, s = n + 1;
              break t;
            }
          i = this.stack[--n];
        }
    for (let i = s; i < this.stack.length; i++)
      e = new et(this.buffer, e, this.stack[i]);
    return this.bufferNode = new et(this.buffer, e, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(t, e) {
    for (let s = 0; ; ) {
      let i = !1;
      if (this.type.isAnonymous || t(this) !== !1) {
        if (this.firstChild()) {
          s++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && e && e(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!s)
          return;
        this.parent(), s--, i = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(t) {
    if (!this.buffer)
      return be(this.node, t);
    let { buffer: e } = this.buffer, { types: s } = e.set;
    for (let i = t.length - 1, n = this.stack.length - 1; i >= 0; n--) {
      if (n < 0)
        return be(this.node, t, i);
      let o = s[e.buffer[this.stack[n]]];
      if (!o.isAnonymous) {
        if (t[i] && t[i] != o.name)
          return !1;
        i--;
      }
    }
    return !0;
  }
}
function Ve(r) {
  return r.children.some((t) => t instanceof st || !t.type.isAnonymous || Ve(t));
}
function Ks(r) {
  var t;
  let { buffer: e, nodeSet: s, maxBufferLength: i = Ss, reused: n = [], minRepeatType: o = s.types.length } = r, l = Array.isArray(e) ? new Re(e, e.length) : e, a = s.types, h = 0, u = 0;
  function $(S, y, j, T, k, b) {
    let { id: g, start: O, end: F, size: w } = l, D = u;
    for (; w < 0; )
      if (l.next(), w == -1) {
        let Z = n[g];
        j.push(Z), T.push(O - S);
        return;
      } else if (w == -3) {
        h = g;
        return;
      } else if (w == -4) {
        u = g;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${w}`);
    let it = a[g], $t, rt, De = O - S;
    if (F - O <= i && (rt = R(l.pos - y, k))) {
      let Z = new Uint16Array(rt.size - rt.skip), C = l.pos - rt.size, B = Z.length;
      for (; l.pos > C; )
        B = I(rt.start, Z, B);
      $t = new st(Z, F - rt.start, s), De = rt.start - S;
    } else {
      let Z = l.pos - w;
      l.next();
      let C = [], B = [], nt = g >= o ? g : -1, ft = 0, Rt = F;
      for (; l.pos > Z; )
        nt >= 0 && l.id == nt && l.size >= 0 ? (l.end <= Rt - i && (d(C, B, O, ft, l.end, Rt, nt, D), ft = C.length, Rt = l.end), l.next()) : b > 2500 ? f(O, Z, C, B) : $(O, Z, C, B, nt, b + 1);
      if (nt >= 0 && ft > 0 && ft < C.length && d(C, B, O, ft, O, Rt, nt, D), C.reverse(), B.reverse(), nt > -1 && ft > 0) {
        let We = c(it);
        $t = ve(it, C, B, 0, C.length, 0, F - O, We, We);
      } else
        $t = m(it, C, B, F - O, D - F);
    }
    j.push($t), T.push(De);
  }
  function f(S, y, j, T) {
    let k = [], b = 0, g = -1;
    for (; l.pos > y; ) {
      let { id: O, start: F, end: w, size: D } = l;
      if (D > 4)
        l.next();
      else {
        if (g > -1 && F < g)
          break;
        g < 0 && (g = w - i), k.push(O, F, w), b++, l.next();
      }
    }
    if (b) {
      let O = new Uint16Array(b * 4), F = k[k.length - 2];
      for (let w = k.length - 3, D = 0; w >= 0; w -= 3)
        O[D++] = k[w], O[D++] = k[w + 1] - F, O[D++] = k[w + 2] - F, O[D++] = D;
      j.push(new st(O, k[2] - F, s)), T.push(F - S);
    }
  }
  function c(S) {
    return (y, j, T) => {
      let k = 0, b = y.length - 1, g, O;
      if (b >= 0 && (g = y[b]) instanceof V) {
        if (!b && g.type == S && g.length == T)
          return g;
        (O = g.prop(x.lookAhead)) && (k = j[b] + g.length + O);
      }
      return m(S, y, j, T, k);
    };
  }
  function d(S, y, j, T, k, b, g, O) {
    let F = [], w = [];
    for (; S.length > T; )
      F.push(S.pop()), w.push(y.pop() + j - k);
    S.push(m(s.types[g], F, w, b - k, O - b)), y.push(k - j);
  }
  function m(S, y, j, T, k = 0, b) {
    if (h) {
      let g = [x.contextHash, h];
      b = b ? [g].concat(b) : [g];
    }
    if (k > 25) {
      let g = [x.lookAhead, k];
      b = b ? [g].concat(b) : [g];
    }
    return new V(S, y, j, T, b);
  }
  function R(S, y) {
    let j = l.fork(), T = 0, k = 0, b = 0, g = j.end - i, O = { size: 0, start: 0, skip: 0 };
    t:
      for (let F = j.pos - S; j.pos > F; ) {
        let w = j.size;
        if (j.id == y && w >= 0) {
          O.size = T, O.start = k, O.skip = b, b += 4, T += 4, j.next();
          continue;
        }
        let D = j.pos - w;
        if (w < 0 || D < F || j.start < g)
          break;
        let it = j.id >= o ? 4 : 0, $t = j.start;
        for (j.next(); j.pos > D; ) {
          if (j.size < 0)
            if (j.size == -3)
              it += 4;
            else
              break t;
          else
            j.id >= o && (it += 4);
          j.next();
        }
        k = $t, T += w, b += it;
      }
    return (y < 0 || T == S) && (O.size = T, O.start = k, O.skip = b), O.size > 4 ? O : void 0;
  }
  function I(S, y, j) {
    let { id: T, start: k, end: b, size: g } = l;
    if (l.next(), g >= 0 && T < o) {
      let O = j;
      if (g > 4) {
        let F = l.pos - (g - 4);
        for (; l.pos > F; )
          j = I(S, y, j);
      }
      y[--j] = O, y[--j] = b - S, y[--j] = k - S, y[--j] = T;
    } else
      g == -3 ? h = T : g == -4 && (u = T);
    return j;
  }
  let z = [], J = [];
  for (; l.pos > 0; )
    $(r.start || 0, r.bufferStart || 0, z, J, -1, 0);
  let N = (t = r.length) !== null && t !== void 0 ? t : z.length ? J[0] + z[0].length : 0;
  return new V(a[r.topID], z.reverse(), J.reverse(), N);
}
const qe = /* @__PURE__ */ new WeakMap();
function At(r, t) {
  if (!r.isAnonymous || t instanceof st || t.type != r)
    return 1;
  let e = qe.get(t);
  if (e == null) {
    e = 1;
    for (let s of t.children) {
      if (s.type != r || !(s instanceof V)) {
        e = 1;
        break;
      }
      e += At(r, s);
    }
    qe.set(t, e);
  }
  return e;
}
function ve(r, t, e, s, i, n, o, l, a) {
  let h = 0;
  for (let d = s; d < i; d++)
    h += At(r, t[d]);
  let u = Math.ceil(
    h * 1.5 / 8
    /* Balance.BranchFactor */
  ), $ = [], f = [];
  function c(d, m, R, I, z) {
    for (let J = R; J < I; ) {
      let N = J, S = m[J], y = At(r, d[J]);
      for (J++; J < I; J++) {
        let j = At(r, d[J]);
        if (y + j >= u)
          break;
        y += j;
      }
      if (J == N + 1) {
        if (y > u) {
          let j = d[N];
          c(j.children, j.positions, 0, j.children.length, m[N] + z);
          continue;
        }
        $.push(d[N]);
      } else {
        let j = m[J - 1] + d[J - 1].length - S;
        $.push(ve(r, d, m, N, J, S, j, null, a));
      }
      f.push(S + z - n);
    }
  }
  return c(t, e, s, i, 0), (l || a)($, f, o);
}
class ut {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(t, e, s, i, n = !1, o = !1) {
    this.from = t, this.to = e, this.tree = s, this.offset = i, this.open = (n ? 1 : 0) | (o ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(t, e = [], s = !1) {
    let i = [new ut(0, t.length, t, 0, !1, s)];
    for (let n of e)
      n.to > t.length && i.push(n);
    return i;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(t, e, s = 128) {
    if (!e.length)
      return t;
    let i = [], n = 1, o = t.length ? t[0] : null;
    for (let l = 0, a = 0, h = 0; ; l++) {
      let u = l < e.length ? e[l] : null, $ = u ? u.fromA : 1e9;
      if ($ - a >= s)
        for (; o && o.from < $; ) {
          let f = o;
          if (a >= f.from || $ <= f.to || h) {
            let c = Math.max(f.from, a) - h, d = Math.min(f.to, $) - h;
            f = c >= d ? null : new ut(c, d, f.tree, f.offset + h, l > 0, !!u);
          }
          if (f && i.push(f), o.to > $)
            break;
          o = n < t.length ? t[n++] : null;
        }
      if (!u)
        break;
      a = u.toA, h = u.toA - u.toB;
    }
    return i;
  }
}
class ys {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(t, e, s) {
    return typeof t == "string" && (t = new Zs(t)), s = s ? s.length ? s.map((i) => new ie(i.from, i.to)) : [new ie(0, 0)] : [new ie(0, t.length)], this.createParse(t, e || [], s);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(t, e, s) {
    let i = this.startParse(t, e, s);
    for (; ; ) {
      let n = i.advance();
      if (n)
        return n;
    }
  }
}
class Zs {
  constructor(t) {
    this.string = t;
  }
  get length() {
    return this.string.length;
  }
  chunk(t) {
    return this.string.slice(t);
  }
  get lineChunks() {
    return !1;
  }
  read(t, e) {
    return this.string.slice(t, e);
  }
}
new x({ perNode: !0 });
class Xt {
  /**
  @internal
  */
  constructor(t, e, s, i, n, o, l, a, h, u = 0, $) {
    this.p = t, this.stack = e, this.state = s, this.reducePos = i, this.pos = n, this.score = o, this.buffer = l, this.bufferBase = a, this.curContext = h, this.lookAhead = u, this.parent = $;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((t, e) => e % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(t, e, s = 0) {
    let i = t.parser.context;
    return new Xt(t, [], e, s, s, 0, [], 0, i ? new Ee(i, i.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(t, e) {
    this.stack.push(this.state, e, this.bufferBase + this.buffer.length), this.state = t;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(t) {
    var e;
    let s = t >> 19, i = t & 65535, { parser: n } = this.p, o = n.dynamicPrecedence(i);
    if (o && (this.score += o), s == 0) {
      this.pushState(n.getGoto(this.state, i, !0), this.reducePos), i < n.minRepeatTerm && this.storeNode(i, this.reducePos, this.reducePos, 4, !0), this.reduceContext(i, this.reducePos);
      return;
    }
    let l = this.stack.length - (s - 1) * 3 - (t & 262144 ? 6 : 0), a = l ? this.stack[l - 2] : this.p.ranges[0].from, h = this.reducePos - a;
    h >= 2e3 && !(!((e = this.p.parser.nodeSet.types[i]) === null || e === void 0) && e.isAnonymous) && (a == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = h) : this.p.lastBigReductionSize < h && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = a, this.p.lastBigReductionSize = h));
    let u = l ? this.stack[l - 1] : 0, $ = this.bufferBase + this.buffer.length - u;
    if (i < n.minRepeatTerm || t & 131072) {
      let f = n.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(i, a, f, $ + 4, !0);
    }
    if (t & 262144)
      this.state = this.stack[l];
    else {
      let f = this.stack[l - 3];
      this.state = n.getGoto(f, i, !0);
    }
    for (; this.stack.length > l; )
      this.stack.pop();
    this.reduceContext(i, a);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(t, e, s, i = 4, n = !1) {
    if (t == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let o = this, l = this.buffer.length;
      if (l == 0 && o.parent && (l = o.bufferBase - o.parent.bufferBase, o = o.parent), l > 0 && o.buffer[l - 4] == 0 && o.buffer[l - 1] > -1) {
        if (e == s)
          return;
        if (o.buffer[l - 2] >= e) {
          o.buffer[l - 2] = s;
          return;
        }
      }
    }
    if (!n || this.pos == s)
      this.buffer.push(t, e, s, i);
    else {
      let o = this.buffer.length;
      if (o > 0 && this.buffer[o - 4] != 0)
        for (; o > 0 && this.buffer[o - 2] > s; )
          this.buffer[o] = this.buffer[o - 4], this.buffer[o + 1] = this.buffer[o - 3], this.buffer[o + 2] = this.buffer[o - 2], this.buffer[o + 3] = this.buffer[o - 1], o -= 4, i > 4 && (i -= 4);
      this.buffer[o] = t, this.buffer[o + 1] = e, this.buffer[o + 2] = s, this.buffer[o + 3] = i;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(t, e, s, i) {
    if (t & 131072)
      this.pushState(t & 65535, this.pos);
    else if (t & 262144)
      this.pos = i, this.shiftContext(e, s), e <= this.p.parser.maxNode && this.buffer.push(e, s, i, 4);
    else {
      let n = t, { parser: o } = this.p;
      (i > this.pos || e <= o.maxNode) && (this.pos = i, o.stateFlag(
        n,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = i)), this.pushState(n, s), this.shiftContext(e, s), e <= o.maxNode && this.buffer.push(e, s, i, 4);
    }
  }
  // Apply an action
  /**
  @internal
  */
  apply(t, e, s, i) {
    t & 65536 ? this.reduce(t) : this.shift(t, e, s, i);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(t, e) {
    let s = this.p.reused.length - 1;
    (s < 0 || this.p.reused[s] != t) && (this.p.reused.push(t), s++);
    let i = this.pos;
    this.reducePos = this.pos = i + t.length, this.pushState(e, i), this.buffer.push(
      s,
      i,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, t, this, this.p.stream.reset(this.pos - t.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let t = this, e = t.buffer.length;
    for (; e > 0 && t.buffer[e - 2] > t.reducePos; )
      e -= 4;
    let s = t.buffer.slice(e), i = t.bufferBase + e;
    for (; t && i == t.bufferBase; )
      t = t.parent;
    return new Xt(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, s, i, this.curContext, this.lookAhead, t);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(t, e) {
    let s = t <= this.p.parser.maxNode;
    s && this.storeNode(t, this.pos, e, 4), this.storeNode(0, this.pos, e, s ? 8 : 4), this.pos = this.reducePos = e, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(t) {
    for (let e = new Ls(this); ; ) {
      let s = this.p.parser.stateSlot(
        e.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(e.state, t);
      if (s == 0)
        return !1;
      if (!(s & 65536))
        return !0;
      e.reduce(s);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(t) {
    if (this.stack.length >= 300)
      return [];
    let e = this.p.parser.nextStates(this.state);
    if (e.length > 8 || this.stack.length >= 120) {
      let i = [];
      for (let n = 0, o; n < e.length; n += 2)
        (o = e[n + 1]) != this.state && this.p.parser.hasAction(o, t) && i.push(e[n], o);
      if (this.stack.length < 120)
        for (let n = 0; i.length < 8 && n < e.length; n += 2) {
          let o = e[n + 1];
          i.some((l, a) => a & 1 && l == o) || i.push(e[n], o);
        }
      e = i;
    }
    let s = [];
    for (let i = 0; i < e.length && s.length < 4; i += 2) {
      let n = e[i + 1];
      if (n == this.state)
        continue;
      let o = this.split();
      o.pushState(n, this.pos), o.storeNode(0, o.pos, o.pos, 4, !0), o.shiftContext(e[i], this.pos), o.reducePos = this.pos, o.score -= 200, s.push(o);
    }
    return s;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: t } = this.p, e = t.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if (!(e & 65536))
      return !1;
    if (!t.validAction(this.state, e)) {
      let s = e >> 19, i = e & 65535, n = this.stack.length - s * 3;
      if (n < 0 || t.getGoto(this.stack[n], i, !1) < 0) {
        let o = this.findForcedReduction();
        if (o == null)
          return !1;
        e = o;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(e), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: t } = this.p, e = [], s = (i, n) => {
      if (!e.includes(i))
        return e.push(i), t.allActions(i, (o) => {
          if (!(o & 393216))
            if (o & 65536) {
              let l = (o >> 19) - n;
              if (l > 1) {
                let a = o & 65535, h = this.stack.length - l * 3;
                if (h >= 0 && t.getGoto(this.stack[h], a, !1) >= 0)
                  return l << 19 | 65536 | a;
              }
            } else {
              let l = s(o, n + 1);
              if (l != null)
                return l;
            }
        });
    };
    return s(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: t } = this.p;
    return t.data[t.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !t.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(t) {
    if (this.state != t.state || this.stack.length != t.stack.length)
      return !1;
    for (let e = 0; e < this.stack.length; e += 3)
      if (this.stack[e] != t.stack[e])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(t) {
    return this.p.parser.dialect.flags[t];
  }
  shiftContext(t, e) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, t, this, this.p.stream.reset(e)));
  }
  reduceContext(t, e) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, t, this, this.p.stream.reset(e)));
  }
  /**
  @internal
  */
  emitContext() {
    let t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(t) {
    if (t != this.curContext.context) {
      let e = new Ee(this.curContext.tracker, t);
      e.hash != this.curContext.hash && this.emitContext(), this.curContext = e;
    }
  }
  /**
  @internal
  */
  setLookAhead(t) {
    t > this.lookAhead && (this.emitLookAhead(), this.lookAhead = t);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
}
class Ee {
  constructor(t, e) {
    this.tracker = t, this.context = e, this.hash = t.strict ? t.hash(e) : 0;
  }
}
class Ls {
  constructor(t) {
    this.start = t, this.state = t.state, this.stack = t.stack, this.base = this.stack.length;
  }
  reduce(t) {
    let e = t & 65535, s = t >> 19;
    s == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (s - 1) * 3;
    let i = this.start.p.parser.getGoto(this.stack[this.base - 3], e, !0);
    this.state = i;
  }
}
class _t {
  constructor(t, e, s) {
    this.stack = t, this.pos = e, this.index = s, this.buffer = t.buffer, this.index == 0 && this.maybeNext();
  }
  static create(t, e = t.bufferBase + t.buffer.length) {
    return new _t(t, e, e - t.bufferBase);
  }
  maybeNext() {
    let t = this.stack.parent;
    t != null && (this.index = this.stack.bufferBase - t.bufferBase, this.stack = t, this.buffer = t.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new _t(this.stack, this.pos, this.index);
  }
}
function It(r, t = Uint16Array) {
  if (typeof r != "string")
    return r;
  let e = null;
  for (let s = 0, i = 0; s < r.length; ) {
    let n = 0;
    for (; ; ) {
      let o = r.charCodeAt(s++), l = !1;
      if (o == 126) {
        n = 65535;
        break;
      }
      o >= 92 && o--, o >= 34 && o--;
      let a = o - 32;
      if (a >= 46 && (a -= 46, l = !0), n += a, l)
        break;
      n *= 46;
    }
    e ? e[i++] = n : e = new t(n);
  }
  return e;
}
class Gt {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const Ae = new Gt();
class Ms {
  /**
  @internal
  */
  constructor(t, e) {
    this.input = t, this.ranges = e, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = Ae, this.rangeIndex = 0, this.pos = this.chunkPos = e[0].from, this.range = e[0], this.end = e[e.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(t, e) {
    let s = this.range, i = this.rangeIndex, n = this.pos + t;
    for (; n < s.from; ) {
      if (!i)
        return null;
      let o = this.ranges[--i];
      n -= s.from - o.to, s = o;
    }
    for (; e < 0 ? n > s.to : n >= s.to; ) {
      if (i == this.ranges.length - 1)
        return null;
      let o = this.ranges[++i];
      n += o.from - s.to, s = o;
    }
    return n;
  }
  /**
  @internal
  */
  clipPos(t) {
    if (t >= this.range.from && t < this.range.to)
      return t;
    for (let e of this.ranges)
      if (e.to > t)
        return Math.max(t, e.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(t) {
    let e = this.chunkOff + t, s, i;
    if (e >= 0 && e < this.chunk.length)
      s = this.pos + t, i = this.chunk.charCodeAt(e);
    else {
      let n = this.resolveOffset(t, 1);
      if (n == null)
        return -1;
      if (s = n, s >= this.chunk2Pos && s < this.chunk2Pos + this.chunk2.length)
        i = this.chunk2.charCodeAt(s - this.chunk2Pos);
      else {
        let o = this.rangeIndex, l = this.range;
        for (; l.to <= s; )
          l = this.ranges[++o];
        this.chunk2 = this.input.chunk(this.chunk2Pos = s), s + this.chunk2.length > l.to && (this.chunk2 = this.chunk2.slice(0, l.to - s)), i = this.chunk2.charCodeAt(0);
      }
    }
    return s >= this.token.lookAhead && (this.token.lookAhead = s + 1), i;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(t, e = 0) {
    let s = e ? this.resolveOffset(e, -1) : this.pos;
    if (s == null || s < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = t, this.token.end = s;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: t, chunkPos: e } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = t, this.chunk2Pos = e, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let t = this.input.chunk(this.pos), e = this.pos + t.length;
      this.chunk = e > this.range.to ? t.slice(0, this.range.to - this.pos) : t, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(t = 1) {
    for (this.chunkOff += t; this.pos + t >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      t -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += t, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(t, e) {
    if (e ? (this.token = e, e.start = t, e.lookAhead = t + 1, e.value = e.extended = -1) : this.token = Ae, this.pos != t) {
      if (this.pos = t, t == this.end)
        return this.setDone(), this;
      for (; t < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; t >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      t >= this.chunkPos && t < this.chunkPos + this.chunk.length ? this.chunkOff = t - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(t, e) {
    if (t >= this.chunkPos && e <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(t - this.chunkPos, e - this.chunkPos);
    if (t >= this.chunk2Pos && e <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(t - this.chunk2Pos, e - this.chunk2Pos);
    if (t >= this.range.from && e <= this.range.to)
      return this.input.read(t, e);
    let s = "";
    for (let i of this.ranges) {
      if (i.from >= e)
        break;
      i.to > t && (s += this.input.read(Math.max(i.from, t), Math.min(i.to, e)));
    }
    return s;
  }
}
class dt {
  constructor(t, e) {
    this.data = t, this.id = e;
  }
  token(t, e) {
    let { parser: s } = e.p;
    Hs(this.data, t, e, this.id, s.data, s.tokenPrecTable);
  }
}
dt.prototype.contextual = dt.prototype.fallback = dt.prototype.extend = !1;
dt.prototype.fallback = dt.prototype.extend = !1;
class Js {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(t, e = {}) {
    this.token = t, this.contextual = !!e.contextual, this.fallback = !!e.fallback, this.extend = !!e.extend;
  }
}
function Hs(r, t, e, s, i, n) {
  let o = 0, l = 1 << s, { dialect: a } = e.p.parser;
  t:
    for (; l & r[o]; ) {
      let h = r[o + 1];
      for (let c = o + 3; c < h; c += 2)
        if ((r[c + 1] & l) > 0) {
          let d = r[c];
          if (a.allows(d) && (t.token.value == -1 || t.token.value == d || ti(d, t.token.value, i, n))) {
            t.acceptToken(d);
            break;
          }
        }
      let u = t.next, $ = 0, f = r[o + 2];
      if (t.next < 0 && f > $ && r[h + f * 3 - 3] == 65535) {
        o = r[h + f * 3 - 1];
        continue t;
      }
      for (; $ < f; ) {
        let c = $ + f >> 1, d = h + c + (c << 1), m = r[d], R = r[d + 1] || 65536;
        if (u < m)
          f = c;
        else if (u >= R)
          $ = c + 1;
        else {
          o = r[d + 2], t.advance();
          continue t;
        }
      }
      break;
    }
}
function Ge(r, t, e) {
  for (let s = t, i; (i = r[s]) != 65535; s++)
    if (i == e)
      return s - t;
  return -1;
}
function ti(r, t, e, s) {
  let i = Ge(e, s, t);
  return i < 0 || Ge(e, s, r) < i;
}
const P = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let re = null;
function Ne(r, t, e) {
  let s = r.cursor(v.IncludeAnonymous);
  for (s.moveTo(t); ; )
    if (!(e < 0 ? s.childBefore(t) : s.childAfter(t)))
      for (; ; ) {
        if ((e < 0 ? s.to < t : s.from > t) && !s.type.isError)
          return e < 0 ? Math.max(0, Math.min(
            s.to - 1,
            t - 25
            /* Safety.Margin */
          )) : Math.min(r.length, Math.max(
            s.from + 1,
            t + 25
            /* Safety.Margin */
          ));
        if (e < 0 ? s.prevSibling() : s.nextSibling())
          break;
        if (!s.parent())
          return e < 0 ? 0 : r.length;
      }
}
class ei {
  constructor(t, e) {
    this.fragments = t, this.nodeSet = e, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let t = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (t) {
      for (this.safeFrom = t.openStart ? Ne(t.tree, t.from + t.offset, 1) - t.offset : t.from, this.safeTo = t.openEnd ? Ne(t.tree, t.to + t.offset, -1) - t.offset : t.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(t.tree), this.start.push(-t.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(t) {
    if (t < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= t; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let e = this.trees.length - 1;
      if (e < 0)
        return this.nextFragment(), null;
      let s = this.trees[e], i = this.index[e];
      if (i == s.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let n = s.children[i], o = this.start[e] + s.positions[i];
      if (o > t)
        return this.nextStart = o, null;
      if (n instanceof V) {
        if (o == t) {
          if (o < this.safeFrom)
            return null;
          let l = o + n.length;
          if (l <= this.safeTo) {
            let a = n.prop(x.lookAhead);
            if (!a || l + a < this.fragment.to)
              return n;
          }
        }
        this.index[e]++, o + n.length >= Math.max(this.safeFrom, t) && (this.trees.push(n), this.start.push(o), this.index.push(0));
      } else
        this.index[e]++, this.nextStart = o + n.length;
    }
  }
}
class si {
  constructor(t, e) {
    this.stream = e, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = t.tokenizers.map((s) => new Gt());
  }
  getActions(t) {
    let e = 0, s = null, { parser: i } = t.p, { tokenizers: n } = i, o = i.stateSlot(
      t.state,
      3
      /* ParseState.TokenizerMask */
    ), l = t.curContext ? t.curContext.hash : 0, a = 0;
    for (let h = 0; h < n.length; h++) {
      if (!(1 << h & o))
        continue;
      let u = n[h], $ = this.tokens[h];
      if (!(s && !u.fallback) && ((u.contextual || $.start != t.pos || $.mask != o || $.context != l) && (this.updateCachedToken($, u, t), $.mask = o, $.context = l), $.lookAhead > $.end + 25 && (a = Math.max($.lookAhead, a)), $.value != 0)) {
        let f = e;
        if ($.extended > -1 && (e = this.addActions(t, $.extended, $.end, e)), e = this.addActions(t, $.value, $.end, e), !u.extend && (s = $, e > f))
          break;
      }
    }
    for (; this.actions.length > e; )
      this.actions.pop();
    return a && t.setLookAhead(a), !s && t.pos == this.stream.end && (s = new Gt(), s.value = t.p.parser.eofTerm, s.start = s.end = t.pos, e = this.addActions(t, s.value, s.end, e)), this.mainToken = s, this.actions;
  }
  getMainToken(t) {
    if (this.mainToken)
      return this.mainToken;
    let e = new Gt(), { pos: s, p: i } = t;
    return e.start = s, e.end = Math.min(s + 1, i.stream.end), e.value = s == i.stream.end ? i.parser.eofTerm : 0, e;
  }
  updateCachedToken(t, e, s) {
    let i = this.stream.clipPos(s.pos);
    if (e.token(this.stream.reset(i, t), s), t.value > -1) {
      let { parser: n } = s.p;
      for (let o = 0; o < n.specialized.length; o++)
        if (n.specialized[o] == t.value) {
          let l = n.specializers[o](this.stream.read(t.start, t.end), s);
          if (l >= 0 && s.p.parser.dialect.allows(l >> 1)) {
            l & 1 ? t.extended = l >> 1 : t.value = l >> 1;
            break;
          }
        }
    } else
      t.value = 0, t.end = this.stream.clipPos(i + 1);
  }
  putAction(t, e, s, i) {
    for (let n = 0; n < i; n += 3)
      if (this.actions[n] == t)
        return i;
    return this.actions[i++] = t, this.actions[i++] = e, this.actions[i++] = s, i;
  }
  addActions(t, e, s, i) {
    let { state: n } = t, { parser: o } = t.p, { data: l } = o;
    for (let a = 0; a < 2; a++)
      for (let h = o.stateSlot(
        n,
        a ? 2 : 1
        /* ParseState.Actions */
      ); ; h += 3) {
        if (l[h] == 65535)
          if (l[h + 1] == 1)
            h = L(l, h + 2);
          else {
            i == 0 && l[h + 1] == 2 && (i = this.putAction(L(l, h + 2), e, s, i));
            break;
          }
        l[h] == e && (i = this.putAction(L(l, h + 1), e, s, i));
      }
    return i;
  }
}
class ii {
  constructor(t, e, s, i) {
    this.parser = t, this.input = e, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new Ms(e, i), this.tokens = new si(t, this.stream), this.topTerm = t.top[1];
    let { from: n } = i[0];
    this.stacks = [Xt.start(this, t.top[0], n)], this.fragments = s.length && this.stream.end - n > t.bufferLength * 4 ? new ei(s, t.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let t = this.stacks, e = this.minStackPos, s = this.stacks = [], i, n;
    if (this.bigReductionCount > 300 && t.length == 1) {
      let [o] = t;
      for (; o.forceReduce() && o.stack.length && o.stack[o.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let o = 0; o < t.length; o++) {
      let l = t[o];
      for (; ; ) {
        if (this.tokens.mainToken = null, l.pos > e)
          s.push(l);
        else {
          if (this.advanceStack(l, s, t))
            continue;
          {
            i || (i = [], n = []), i.push(l);
            let a = this.tokens.getMainToken(l);
            n.push(a.value, a.end);
          }
        }
        break;
      }
    }
    if (!s.length) {
      let o = i && ni(i);
      if (o)
        return P && console.log("Finish with " + this.stackID(o)), this.stackToTree(o);
      if (this.parser.strict)
        throw P && i && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + e);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && i) {
      let o = this.stoppedAt != null && i[0].pos > this.stoppedAt ? i[0] : this.runRecovery(i, n, s);
      if (o)
        return P && console.log("Force-finish " + this.stackID(o)), this.stackToTree(o.forceAll());
    }
    if (this.recovering) {
      let o = this.recovering == 1 ? 1 : this.recovering * 3;
      if (s.length > o)
        for (s.sort((l, a) => a.score - l.score); s.length > o; )
          s.pop();
      s.some((l) => l.reducePos > e) && this.recovering--;
    } else if (s.length > 1) {
      t:
        for (let o = 0; o < s.length - 1; o++) {
          let l = s[o];
          for (let a = o + 1; a < s.length; a++) {
            let h = s[a];
            if (l.sameState(h) || l.buffer.length > 500 && h.buffer.length > 500)
              if ((l.score - h.score || l.buffer.length - h.buffer.length) > 0)
                s.splice(a--, 1);
              else {
                s.splice(o--, 1);
                continue t;
              }
          }
        }
      s.length > 12 && s.splice(
        12,
        s.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = s[0].pos;
    for (let o = 1; o < s.length; o++)
      s[o].pos < this.minStackPos && (this.minStackPos = s[o].pos);
    return null;
  }
  stopAt(t) {
    if (this.stoppedAt != null && this.stoppedAt < t)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = t;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(t, e, s) {
    let i = t.pos, { parser: n } = this, o = P ? this.stackID(t) + " -> " : "";
    if (this.stoppedAt != null && i > this.stoppedAt)
      return t.forceReduce() ? t : null;
    if (this.fragments) {
      let h = t.curContext && t.curContext.tracker.strict, u = h ? t.curContext.hash : 0;
      for (let $ = this.fragments.nodeAt(i); $; ) {
        let f = this.parser.nodeSet.types[$.type.id] == $.type ? n.getGoto(t.state, $.type.id) : -1;
        if (f > -1 && $.length && (!h || ($.prop(x.contextHash) || 0) == u))
          return t.useNode($, f), P && console.log(o + this.stackID(t) + ` (via reuse of ${n.getName($.type.id)})`), !0;
        if (!($ instanceof V) || $.children.length == 0 || $.positions[0] > 0)
          break;
        let c = $.children[0];
        if (c instanceof V && $.positions[0] == 0)
          $ = c;
        else
          break;
      }
    }
    let l = n.stateSlot(
      t.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (l > 0)
      return t.reduce(l), P && console.log(o + this.stackID(t) + ` (via always-reduce ${n.getName(
        l & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (t.stack.length >= 8400)
      for (; t.stack.length > 6e3 && t.forceReduce(); )
        ;
    let a = this.tokens.getActions(t);
    for (let h = 0; h < a.length; ) {
      let u = a[h++], $ = a[h++], f = a[h++], c = h == a.length || !s, d = c ? t : t.split(), m = this.tokens.mainToken;
      if (d.apply(u, $, m ? m.start : d.pos, f), P && console.log(o + this.stackID(d) + ` (via ${u & 65536 ? `reduce of ${n.getName(
        u & 65535
        /* Action.ValueMask */
      )}` : "shift"} for ${n.getName($)} @ ${i}${d == t ? "" : ", split"})`), c)
        return !0;
      d.pos > i ? e.push(d) : s.push(d);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(t, e) {
    let s = t.pos;
    for (; ; ) {
      if (!this.advanceStack(t, null, null))
        return !1;
      if (t.pos > s)
        return Be(t, e), !0;
    }
  }
  runRecovery(t, e, s) {
    let i = null, n = !1;
    for (let o = 0; o < t.length; o++) {
      let l = t[o], a = e[o << 1], h = e[(o << 1) + 1], u = P ? this.stackID(l) + " -> " : "";
      if (l.deadEnd && (n || (n = !0, l.restart(), P && console.log(u + this.stackID(l) + " (restarted)"), this.advanceFully(l, s))))
        continue;
      let $ = l.split(), f = u;
      for (let c = 0; $.forceReduce() && c < 10 && (P && console.log(f + this.stackID($) + " (via force-reduce)"), !this.advanceFully($, s)); c++)
        P && (f = this.stackID($) + " -> ");
      for (let c of l.recoverByInsert(a))
        P && console.log(u + this.stackID(c) + " (via recover-insert)"), this.advanceFully(c, s);
      this.stream.end > l.pos ? (h == l.pos && (h++, a = 0), l.recoverByDelete(a, h), P && console.log(u + this.stackID(l) + ` (via recover-delete ${this.parser.getName(a)})`), Be(l, s)) : (!i || i.score < l.score) && (i = l);
    }
    return i;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(t) {
    return t.close(), V.build({
      buffer: _t.create(t),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: t.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(t) {
    let e = (re || (re = /* @__PURE__ */ new WeakMap())).get(t);
    return e || re.set(t, e = String.fromCodePoint(this.nextStackID++)), e + t;
  }
}
function Be(r, t) {
  for (let e = 0; e < t.length; e++) {
    let s = t[e];
    if (s.pos == r.pos && s.sameState(r)) {
      t[e].score < r.score && (t[e] = r);
      return;
    }
  }
  t.push(r);
}
class ri {
  constructor(t, e, s) {
    this.source = t, this.flags = e, this.disabled = s;
  }
  allows(t) {
    return !this.disabled || this.disabled[t] == 0;
  }
}
class Yt extends ys {
  /**
  @internal
  */
  constructor(t) {
    if (super(), this.wrappers = [], t.version != 14)
      throw new RangeError(`Parser version (${t.version}) doesn't match runtime version (14)`);
    let e = t.nodeNames.split(" ");
    this.minRepeatTerm = e.length;
    for (let l = 0; l < t.repeatNodeCount; l++)
      e.push("");
    let s = Object.keys(t.topRules).map((l) => t.topRules[l][1]), i = [];
    for (let l = 0; l < e.length; l++)
      i.push([]);
    function n(l, a, h) {
      i[l].push([a, a.deserialize(String(h))]);
    }
    if (t.nodeProps)
      for (let l of t.nodeProps) {
        let a = l[0];
        typeof a == "string" && (a = x[a]);
        for (let h = 1; h < l.length; ) {
          let u = l[h++];
          if (u >= 0)
            n(u, a, l[h++]);
          else {
            let $ = l[h + -u];
            for (let f = -u; f > 0; f--)
              n(l[h++], a, $);
            h++;
          }
        }
      }
    this.nodeSet = new Fe(e.map((l, a) => W.define({
      name: a >= this.minRepeatTerm ? void 0 : l,
      id: a,
      props: i[a],
      top: s.indexOf(a) > -1,
      error: a == 0,
      skipped: t.skippedNodes && t.skippedNodes.indexOf(a) > -1
    }))), t.propSources && (this.nodeSet = this.nodeSet.extend(...t.propSources)), this.strict = !1, this.bufferLength = Ss;
    let o = It(t.tokenData);
    this.context = t.context, this.specializerSpecs = t.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let l = 0; l < this.specializerSpecs.length; l++)
      this.specialized[l] = this.specializerSpecs[l].term;
    this.specializers = this.specializerSpecs.map(Xe), this.states = It(t.states, Uint32Array), this.data = It(t.stateData), this.goto = It(t.goto), this.maxTerm = t.maxTerm, this.tokenizers = t.tokenizers.map((l) => typeof l == "number" ? new dt(o, l) : l), this.topRules = t.topRules, this.dialects = t.dialects || {}, this.dynamicPrecedences = t.dynamicPrecedences || null, this.tokenPrecTable = t.tokenPrec, this.termNames = t.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(t, e, s) {
    let i = new ii(this, t, e, s);
    for (let n of this.wrappers)
      i = n(i, t, e, s);
    return i;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(t, e, s = !1) {
    let i = this.goto;
    if (e >= i[0])
      return -1;
    for (let n = i[e + 1]; ; ) {
      let o = i[n++], l = o & 1, a = i[n++];
      if (l && s)
        return a;
      for (let h = n + (o >> 1); n < h; n++)
        if (i[n] == t)
          return a;
      if (l)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(t, e) {
    let s = this.data;
    for (let i = 0; i < 2; i++)
      for (let n = this.stateSlot(
        t,
        i ? 2 : 1
        /* ParseState.Actions */
      ), o; ; n += 3) {
        if ((o = s[n]) == 65535)
          if (s[n + 1] == 1)
            o = s[n = L(s, n + 2)];
          else {
            if (s[n + 1] == 2)
              return L(s, n + 2);
            break;
          }
        if (o == e || o == 0)
          return L(s, n + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(t, e) {
    return this.states[t * 6 + e];
  }
  /**
  @internal
  */
  stateFlag(t, e) {
    return (this.stateSlot(
      t,
      0
      /* ParseState.Flags */
    ) & e) > 0;
  }
  /**
  @internal
  */
  validAction(t, e) {
    return !!this.allActions(t, (s) => s == e ? !0 : null);
  }
  /**
  @internal
  */
  allActions(t, e) {
    let s = this.stateSlot(
      t,
      4
      /* ParseState.DefaultReduce */
    ), i = s ? e(s) : void 0;
    for (let n = this.stateSlot(
      t,
      1
      /* ParseState.Actions */
    ); i == null; n += 3) {
      if (this.data[n] == 65535)
        if (this.data[n + 1] == 1)
          n = L(this.data, n + 2);
        else
          break;
      i = e(L(this.data, n + 1));
    }
    return i;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(t) {
    let e = [];
    for (let s = this.stateSlot(
      t,
      1
      /* ParseState.Actions */
    ); ; s += 3) {
      if (this.data[s] == 65535)
        if (this.data[s + 1] == 1)
          s = L(this.data, s + 2);
        else
          break;
      if (!(this.data[s + 2] & 1)) {
        let i = this.data[s + 1];
        e.some((n, o) => o & 1 && n == i) || e.push(this.data[s], i);
      }
    }
    return e;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(t) {
    let e = Object.assign(Object.create(Yt.prototype), this);
    if (t.props && (e.nodeSet = this.nodeSet.extend(...t.props)), t.top) {
      let s = this.topRules[t.top];
      if (!s)
        throw new RangeError(`Invalid top rule name ${t.top}`);
      e.top = s;
    }
    return t.tokenizers && (e.tokenizers = this.tokenizers.map((s) => {
      let i = t.tokenizers.find((n) => n.from == s);
      return i ? i.to : s;
    })), t.specializers && (e.specializers = this.specializers.slice(), e.specializerSpecs = this.specializerSpecs.map((s, i) => {
      let n = t.specializers.find((l) => l.from == s.external);
      if (!n)
        return s;
      let o = Object.assign(Object.assign({}, s), { external: n.to });
      return e.specializers[i] = Xe(o), o;
    })), t.contextTracker && (e.context = t.contextTracker), t.dialect && (e.dialect = this.parseDialect(t.dialect)), t.strict != null && (e.strict = t.strict), t.wrap && (e.wrappers = e.wrappers.concat(t.wrap)), t.bufferLength != null && (e.bufferLength = t.bufferLength), e;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(t) {
    return this.termNames ? this.termNames[t] : String(t <= this.maxNode && this.nodeSet.types[t].name || t);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(t) {
    let e = this.dynamicPrecedences;
    return e == null ? 0 : e[t] || 0;
  }
  /**
  @internal
  */
  parseDialect(t) {
    let e = Object.keys(this.dialects), s = e.map(() => !1);
    if (t)
      for (let n of t.split(" ")) {
        let o = e.indexOf(n);
        o >= 0 && (s[o] = !0);
      }
    let i = null;
    for (let n = 0; n < e.length; n++)
      if (!s[n])
        for (let o = this.dialects[e[n]], l; (l = this.data[o++]) != 65535; )
          (i || (i = new Uint8Array(this.maxTerm + 1)))[l] = 1;
    return new ri(t, s, i);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(t) {
    return new Yt(t);
  }
}
function L(r, t) {
  return r[t] | r[t + 1] << 16;
}
function ni(r) {
  let t = null;
  for (let e of r) {
    let s = e.p.stoppedAt;
    (e.pos == e.p.stream.end || s != null && e.pos > s) && e.p.parser.stateFlag(
      e.state,
      2
      /* StateFlag.Accepting */
    ) && (!t || t.score < e.score) && (t = e);
  }
  return t;
}
function Xe(r) {
  if (r.external) {
    let t = r.extend ? 1 : 0;
    return (e, s) => r.external(e, s) << 1 | t;
  }
  return r.get;
}
const ws = 1, Ts = 2, Ie = 4, oi = 7, te = 8, li = 9, ai = 10, hi = 11, ze = 12, Fs = 14, ui = 16, $i = 17, zt = "'", Dt = 0, _e = 1, Ye = 2;
function fi(r, t, e, s = Dt, i) {
  let n = s;
  const o = [];
  let l;
  t:
    for (; (l = r.next) !== -1; ) {
      const a = Se(l);
      if (i != null && i.has(a))
        break t;
      switch (n) {
        case Dt:
          if (a === zt)
            n = Ye;
          else if (e.has(a))
            break t;
          o.push(a);
          break;
        case Ye:
          t.has(a) ? n = _e : n = Dt, o.push(a);
          break;
        case _e:
          a === zt && (Se(r.peek(1)) === zt ? (r.advance(), o.push(zt)) : n = Dt), o.push(a);
          break;
      }
      r.advance();
    }
  return o.join("");
}
function ci(r, t, e, s) {
  const i = r.pos;
  fi(r, t, e), i < r.pos && r.acceptToken(s);
}
function Rs(r) {
  const t = /* @__PURE__ */ new Set(["{", "}"]);
  return r && t.add("#"), t;
}
function Vs(r) {
  const t = /* @__PURE__ */ new Set(["{"]);
  return r && (t.add("#"), t.add("}")), t;
}
function vs({ input: r, escapable: t, ending: e, textToken: s }) {
  return ci(r, t, e, s);
}
const pi = new Js((r) => vs({
  input: r,
  escapable: Rs(!1),
  ending: Vs(!1),
  textToken: ws
})), di = new Js((r) => vs({
  input: r,
  escapable: Rs(!0),
  ending: Vs(!0),
  textToken: Ts
})), Ft = Yt.deserialize({
  version: 14,
  states: "/SQQOTOOQ]OUOOOOOO'#Ca'#CaOOOR'#Cm'#CmOhOSO'#C`OpOTO'#CtQOOOOOO!OOUO'#C}OOOO'#Cd'#CdO!aOSO'#CcOkOSO'#CcO!lOSO,58zOOOO,59`,59`OOOO,59i,59iO!qOWO,58}O!|OSO,58}O#UOSO,58}OOOR'#Co'#CoOOOR1G.f1G.fOOOO'#Ce'#CeO#aOSO1G.iO!tOWO1G.iOOOO'#Ch'#ChO#lOSO1G.mO#tOWO1G.iO$POSO1G.iO$XO`O7+$TO$aOSO7+$TO$iOSO7+$TO$tOSO7+$XO$|OpO7+$XO$wOSO7+$XO!tOWO7+$TO%XOWO7+$TOOOO'#Cf'#CfOOOO'#Cq'#CqO$[O`O'#CqO%dO`O<<GoO$XO`O<<GoO%oOSO<<GoO%wOpO<<GsO&SOSO<<GsOOOO'#Ci'#CiOOOO'#Ck'#CkO&XOSO'#CjOOOO'#Cr'#CrO%POpO<<GsO&aOpO<<GsO&lOpO<<GsO&tOSO<<GoO'POSO<<GsO!tOWO<<GoOOOO,59],59]O'XO`OAN=ZOOOO-E6o-E6oO'aO`OAN=ZO$XO`OAN=ZO%POpOAN=_O'lOpOAN=_O&lOpOAN=_O'wOpOAN=_O(SOUO,59UO(bOSO,59UOOOO,59^,59^O'oOpOAN=_OOOO-E6p-E6pO%SOpO'#CrO(gOSOAN=ZO(oOSOAN=_O(tOSOAN=ZO)POSOAN=_O)XO`OG22uO)aO`OG22uO&lOpOG22yO)lOpOG22yO)tOpOG22yO%POpOG22yOOOO'#Cl'#ClO*POSO1G.pO(SOUO1G.pO$XO`OG22uO*UOpOG22yO*aOSOG22uO*iOSOG22yO*nO`OLD(aO*vOpOLD(eO*yOpOLD(eO&lOpOLD(eOOOO7+$[7+$[O+ROSO7+$[O+WO`OLD(aO%POpOLD(eO$XO`OLD(aO+cOpOLD(eO+nOpO!$'LPO+vOpO!$'LPOOOO<<Gv<<GvO,RO`O!$'K{O&lOpO!$'LPO,ZO`O!$'K{O%POpO!$'LPO,fOpO!)9AkO,nOpO!)9AkO,yO`O!)9AgO&lOpO!)9AkO-ROpO!.K7VO-ZOpO!.K7VO-fOpO!4/,q",
  stateData: "-q~OPTOUQOrRO~OQVOUQOrRO~OiYOjWO~OPTOUQOrROghX~OQVOUQOrROgqXbqX~Oi_Ok^ObVX~ObaO~OieOlcOnfO~OkhObVa~OiiOkhObVa~OikOkjObVi~OioOknO~OipOlcOnfO~OkqObVi~OitOmrO~OkvObVq~OiwOkvObVq~OiyOkxO~Oi!OOozOp{O~Oi!TOlcOnfO~Oi!VOmrObVy~Ok!YObVy~Oi!ZOozOp{O~Ok!^O~OU!_Oi!`O~Oi!bOp{ObZy~Oi!dOp{O~Oi!eOk!YObVy~Oi!fOk!^O~OmrObV!R~Oi!iOmrObV!R~Oi!lOp{ObZ!R~Oi!nOozOp{O~OQVOUQOrROb`P~OU!qO~Ok!rObV!R~Ok!sO~Oi!tOk!rObV!R~Oi!uOk!sO~OmrObV!Z~Oi!vOmrObV!Z~Op{ObZ!Z~Oi!xOp{ObZ!Z~Ob!zO~Oi!}OozOp{O~Ok#OObV!Z~Ok#PO~OmrObV!c~Oi#QOp{ObZ!c~Ob#SO~Oi#TOmrObV!c~Oi#WOozOp{O~Op{ObZ!k~Oi#XOp{ObZ!k~OmrObV!k~Oi#ZOmrObV!k~Op{ObZ!s~Oi#]Op{ObZ!s~OmrObV!s~Op{ObZ!{~Oi#_Op{ObZ!{~Op{ObZ#T~Oop~",
  goto: "'TrPPPPs}P!V!Y!`!n!V#S#b#x$m%`sP%fP%i&PP&sPPPPPPPP&ySTOTXVPV!_!q]SOPTV!_!qRZSQXSR`YQd^SlehS!RpqR!g!Tdsjuv!X!Y!j!r!|#O#V]!Ut!V!i!v#T#ZQg^SmehS!SpqR!h!TQ!QnS!]x!OS!k!Z!^S!y!n!sS#U!}#PR#[#Wt}nx!P!Q![!]!^!k!m!s!w!y#P#R#U#Y#[#^k!a!O!Z!b!d!l!n!x!}#Q#W#X#]#_!a|nx!O!P!Q!Z![!]!^!b!d!k!l!m!n!s!w!x!y!}#P#Q#R#U#W#X#Y#[#]#^#_Q!p!_R!{!qRbZQujY!Wu!X!j!|#VQ!XvQ!j!YQ!|!rR#V#OQ!PnS![x!Q^!c!P![!m!w#R#Y#^S!m!]!^S!w!k!sS#R!y#PQ#Y#UR#^#[QUOR[TQUPQ]VT!o!_!q",
  nodeNames: "⚠ Text TextNested Root Expression ExpressionOpen { FormatExpression Param FormatFunction FormatStyle SelectExpression SelectFunction Offset SelectVariant VariantDescriptor VariantContent PluralPlaceholder } ExpressionClose Nested",
  maxTerm: 34,
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "$Mn~R#POX'UX^,z^p'Upq,zqs+jst-ot{+j{|.u|}7o}!O.u!O!Q+j!Q!['U![!_+j!_!`7t!`!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#W'U#W#X<[#X#b'U#b#cNa#c#d!7X#d#e#(`#e#g'U#g#h#Ck#h#i$C]#i#o'U#o#p$Lc#p#q+j#q#r$Mi#r#s+j#s#y'U#y#z,z#z$f'U$f$g,z$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BY#BZ,z#BZ$IS'U$IS$I_,z$I_$Id'U$Id$I|+j$I|$JO,z$JO$JT'U$JT$JU,z$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KV$KW,z$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FU&FV,z&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U]'_!cmSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'US+o_mSOX+j^p+jq|+j}#q+j#r#y+j#z$f+j$g#BY+j#BZ$IS+j$I_$I|+j$JO$JT+j$JU$KV+j$KW&FU+j&FV;'S+j;'S;=`,n<%lO+jS,qP;=`<%l+j],wP;=`<%l'U~-PYi~X^,zpq,z#y#z,z$f$g,z#BY#BZ,z$IS$I_,z$I|$JO,z$JT$JU,z$KV$KW,z&FU&FV,zT-v_mSrPOX+j^p+jq|+j}#q+j#r#y+j#z$f+j$g#BY+j#BZ$IS+j$I_$I|+j$JO$JT+j$JU$KV+j$KW&FU+j&FV;'S+j;'S;=`,n<%lO+j[.z!cmSOX3V^p3Vq|+j}!Q+j!Q![3V![!c+j!c!}3V!}#R+j#R#S3V#S#T+j#T#o3V#o#q+j#r#s+j#s#y3V#z$f3V$g$n+j$n$o3V$o$p+j$p$q3V$q$s+j$s$t3V$t$u+j$u$v3V$v$x+j$x$|3V$|$}+j$}%R3V%R%S+j%S%V3V%V%W+j%W%o3V%o%p+j%p&a3V&a&b+j&b#BY3V#BZ$IS3V$I_$Id3V$Id$I|+j$JO$JT3V$JU$Je+j$Je$Jg3V$Jg$Jz+j$Jz$J{3V$J{$KV+j$KW%#t3V%#t%3d+j%3d%6z3V%6z%Dl+j%Dl%E[3V%E[&/x+j&/x&;O3V&;O&=t+j&=t&FU3V&FV&FY+j&FY&F^3V&F^&Fw+j&Fw&GW3V&GW&GX+j&GX;'S3V;'S;=`7i<%l?>`3V?>`?>b+j?>b?DR3V?DR?DT+j?DTO3V[3^!cmSpWOX3V^p3Vq|+j}!Q+j!Q![3V![!c+j!c!}3V!}#R+j#R#S3V#S#T+j#T#o3V#o#q+j#r#s+j#s#y3V#z$f3V$g$n+j$n$o3V$o$p+j$p$q3V$q$s+j$s$t3V$t$u+j$u$v3V$v$x+j$x$|3V$|$}+j$}%R3V%R%S+j%S%V3V%V%W+j%W%o3V%o%p+j%p&a3V&a&b+j&b#BY3V#BZ$IS3V$I_$Id3V$Id$I|+j$JO$JT3V$JU$Je+j$Je$Jg3V$Jg$Jz+j$Jz$J{3V$J{$KV+j$KW%#t3V%#t%3d+j%3d%6z3V%6z%Dl+j%Dl%E[3V%E[&/x+j&/x&;O3V&;O&=t+j&=t&FU3V&FV&FY+j&FY&F^3V&F^&Fw+j&Fw&GW3V&GW&GX+j&GX;'S3V;'S;=`7i<%l?>`3V?>`?>b+j?>b?DR3V?DR?DT+j?DTO3V[7lP;=`<%l3V~7tOk~[7y!emSOX3V^p3Vq{+j{|.u}!O.u!O!Q+j!Q![3V![!c+j!c!}3V!}#R+j#R#S3V#S#T+j#T#o3V#o#q+j#r#s+j#s#y3V#z$f3V$g$n+j$n$o3V$o$p+j$p$q3V$q$s+j$s$t3V$t$u+j$u$v3V$v$x+j$x$|3V$|$}+j$}%R3V%R%S+j%S%V3V%V%W+j%W%o3V%o%p+j%p&a3V&a&b+j&b#BY3V#BZ$IS3V$I_$Id3V$Id$I|+j$JO$JT3V$JU$Je+j$Je$Jg3V$Jg$Jz+j$Jz$J{3V$J{$KV+j$KW%#t3V%#t%3d+j%3d%6z3V%6z%Dl+j%Dl%E[3V%E[&/x+j&/x&;O3V&;O&=t+j&=t&FU3V&FV&FY+j&FY&F^3V&F^&Fw+j&Fw&GW3V&GW&GX+j&GX;'S3V;'S;=`7i<%l?>`3V?>`?>b+j?>b?DR3V?DR?DT+j?DTO3V_<e!dmSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#U@s#U#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_@|!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#h'U#h#iE_#i#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_Eh!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#X'U#X#YIy#Y#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_JU!clQmSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_Nj!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#i'U#i#j!${#j#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_!%U!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#a'U#a#b!)g#b#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_!)p!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#U'U#U#V!.R#V#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_!.[!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#X'U#X#Y!2m#Y#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_!2v!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#f'U#f#gIy#g#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U]!7b!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#Y'U#Y#Z!;s#Z#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U]!;|!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#Y'U#Y#Z!@_#Z#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U]!@h!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#g'U#g#h!Dy#h#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U]!ES!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#X'U#X#Y!Ie#Y#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U]!In!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#h'U#h#i!NP#i#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U]!NY!dmSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!]#$h!]!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U[#$mcmSOX+j^p+jq{+j{|#%x}!O#%x!O!Q+j!Q![#'S![#q+j#r#y+j#z$f+j$g#BY+j#BZ$IS+j$I_$I|+j$JO$JT+j$JU$KV+j$KW&FU+j&FV;'S+j;'S;=`,n<%lO+j[#%}amSOX+j^p+jq|+j}!Q+j!Q![#'S![#q+j#r#y+j#z$f+j$g#BY+j#BZ$IS+j$I_$I|+j$JO$JT+j$JU$KV+j$KW&FU+j&FV;'S+j;'S;=`,n<%lO+j[#'ZamSoWOX+j^p+jq|+j}!Q+j!Q![#'S![#q+j#r#y+j#z$f+j$g#BY+j#BZ$IS+j$I_$I|+j$JO$JT+j$JU$KV+j$KW&FU+j&FV;'S+j;'S;=`,n<%lO+j_#(i!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#`'U#`#a#,z#a#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_#-T!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#i'U#i#j#1f#j#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_#1o!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#f'U#f#g#6Q#g#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_#6Z!dmSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#U#:i#U#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_#:r!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#`'U#`#a#?T#a#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_#?`!cmSjPnQpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_#Ct!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#X'U#X#Y#HV#Y#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_#H`!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#`'U#`#a#Lq#a#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_#Lz!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#X'U#X#Y$#]#Y#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_$#f!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#V'U#V#W$'w#W#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_$(Q!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#h'U#h#i$,c#i#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_$,n!emSjPnQpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#c'U#c#d$1P#d#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_$1Y!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#f'U#f#g$5k#g#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_$5t!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#W'U#W#X$:V#X#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_$:`!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#]'U#]#^$>q#^#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_$>z!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#b'U#b#c#6Q#c#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_$Cf!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#]'U#]#^$Gw#^#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'U_$HQ!emSjPpWOX'U^p'Uq|+j}!Q+j!Q!['U![!c+j!c!}'U!}#R+j#R#S'U#S#T+j#T#a'U#a#bE_#b#o'U#o#q+j#r#s+j#s#y'U#z$f'U$g$n+j$n$o'U$o$p+j$p$q'U$q$s+j$s$t'U$t$u+j$u$v'U$v$x+j$x$|'U$|$}+j$}%R'U%R%S+j%S%V'U%V%W+j%W%o'U%o%p+j%p&a'U&a&b+j&b#BY'U#BZ$IS'U$I_$Id'U$Id$I|+j$JO$JT'U$JU$Je+j$Je$Jg'U$Jg$Jz+j$Jz$J{'U$J{$KV+j$KW%#t'U%#t%3d+j%3d%6z'U%6z%Dl+j%Dl%E['U%E[&/x+j&/x&;O'U&;O&=t+j&=t&FU'U&FV&FY+j&FY&F^'U&F^&Fw+j&Fw&GW'U&GW&GX+j&GX;'S'U;'S;=`,t<%l?>`'U?>`?>b+j?>b?DR'U?DR?DT+j?DTO'UT$Lj_UPmSOX+j^p+jq|+j}#q+j#r#y+j#z$f+j$g#BY+j#BZ$IS+j$I_$I|+j$JO$JT+j$JU$KV+j$KW&FU+j&FV;'S+j;'S;=`,n<%lO+j~$MnOb~",
  tokenizers: [pi, di, 0, 1, 2, 3],
  topRules: { Root: [0, 3], Nested: [1, 20] },
  tokenPrec: 582
}), Ui = (r) => {
  let t = 0;
  return {
    get next() {
      return r[t] ? r.charCodeAt(t) : -1;
    },
    get pos() {
      return t;
    },
    peek(s) {
      return r[t + s] ? r.charCodeAt(t + s) : -1;
    },
    advance(s = 1) {
      t += s;
    }
  };
};
function gt(r) {
  return r === 45 || r === 46 || r >= 48 && r <= 57 || r === 95 || r >= 97 && r <= 122 || r >= 65 && r <= 90 || r == 183 || r >= 192 && r <= 214 || r >= 216 && r <= 246 || r >= 248 && r <= 893 || r >= 895 && r <= 8191 || r >= 8204 && r <= 8205 || r >= 8255 && r <= 8256 || r >= 8304 && r <= 8591 || r >= 11264 && r <= 12271 || r >= 12289 && r <= 55295 || r >= 63744 && r <= 64975 || r >= 65008 && r <= 65533 || r >= 65536 && r <= 983039;
}
function Wt(r) {
  return r >= 9 && r <= 13 || r === 32 || r === 133 || r >= 8206 && r <= 8207 || r === 8232 || r === 8233;
}
const Qe = 0, Ke = 1, ne = 2, ot = 4, Ot = 5, oe = 6, le = 7, Ze = 8, ae = 9, Le = 10;
function ji(r) {
  let t = Qe, e = "open", s = "", i = "", n = "", o = "'", l;
  const a = { start: 0, end: 0 }, h = {};
  t:
    for (; (l = r.next) !== -1; ) {
      const u = Se(l);
      switch (t) {
        case Qe:
          u === "<" && (t = Ke, a.start = r.pos);
          break;
        case Ke:
          if (u === "/")
            e = "close", t = ne;
          else if (gt(l))
            s += u, t = ne;
          else
            break t;
          break;
        case ne:
          if (u === ">") {
            if (s === "")
              break t;
            t = ot;
          } else if (u === "/") {
            if (s === "")
              break t;
            e = "self-closed", t = Ot;
          } else if (Wt(l)) {
            if (s === "")
              break t;
            t = oe;
          } else if (gt(l))
            s += u;
          else
            break t;
          break;
        case oe:
          gt(l) ? (i += u, t = le) : u === "/" ? (e = "self-closed", t = Ot) : u === ">" && (t = ot);
          break;
        case le:
          if (gt(l))
            i += u;
          else if (u === ">" || u === "/" || u === "=" || Wt(l))
            h[i] = !0, u === ">" ? t = ot : u === "/" ? t = Ot : u === "=" ? t = ae : t = Ze;
          else
            break t;
          break;
        case Ze:
          if (u === ">")
            t = ot;
          else if (u === "/")
            t = Ot;
          else if (u === "=")
            t = ae;
          else if (gt(l))
            t = le, i = u;
          else if (!Wt(l))
            break t;
          break;
        case ae:
          if (u === "'" || u === '"')
            t = Le, o = u;
          else if (!Wt(l))
            break t;
          break;
        case Le:
          u === o ? (h[i] = `${o}${n}${o}`, i = "", n = "", t = oe) : n += u;
          break;
        case Ot: {
          if (u === ">")
            t = ot;
          else
            break t;
          break;
        }
        case ot:
          break t;
      }
      r.advance();
    }
  return t === ot && s ? (a.end = r.pos, {
    isTag: !0,
    type: e,
    name: s,
    params: h,
    position: a
  }) : null;
}
const gi = (r) => {
  const t = Ui(r), e = [];
  for (; t.next !== -1; ) {
    const s = ji(t);
    s && e.push(s);
  }
  return e;
};
function Oi(r) {
  const t = [];
  let e = r.firstChild;
  for (; e; )
    t.push(e), e = e.nextSibling;
  return t;
}
const mi = (r, t) => {
  let e;
  try {
    e = Ft.configure({
      strict: !0,
      top: t ? "Nested" : "Root"
    }).parse(r);
  } catch {
    return null;
  }
  const s = [], i = /* @__PURE__ */ new Map();
  function n(f) {
    return r.substring(f.from, f.to);
  }
  function o(f) {
    const c = f.parent;
    let d = "", m;
    const R = [];
    Oi(f).forEach((z) => {
      const J = n(z);
      switch (z.type.id) {
        case te:
          d = J;
          break;
        case li:
          m = J;
          break;
        case ai:
          R.push(J);
          break;
      }
    });
    const I = ["{", d];
    return m && (I.push(", "), I.push(m)), R.length && I.push(`, ${R.join(" ")}`), I.push("}"), {
      position: { start: c.from, end: c.to },
      type: "variable",
      name: d,
      normalizedValue: I.join("")
    };
  }
  function l(f) {
    let c = "<";
    return f.type === "close" && (c += "/"), c += f.name, Object.entries(f.params).forEach(([d, m]) => {
      c += ` ${d}`, m !== !0 && (c += `=${m}`);
    }), f.type === "self-closed" ? c += " />" : c += ">", c;
  }
  function a(f) {
    return {
      position: f.position,
      type: f.type === "open" ? "tagOpen" : f.type === "close" ? "tagClose" : "tagSelfClosed",
      name: f.name,
      normalizedValue: l(f)
    };
  }
  function h(f) {
    if (!r.substring(
      f.position.start,
      f.position.end
    ).includes(`
`)) {
      if (f.type === "tagOpen") {
        const d = i.get(f.name) ?? [];
        d.push(f), i.set(f.name, d);
      } else if (f.type === "tagClose") {
        const d = i.get(f.name);
        d ? (d.pop(), d.length === 0 && i.delete(f.name)) : f.error = "missing_open_tag";
      }
      s.push(f);
    }
  }
  const u = e.cursor();
  let $;
  do {
    const f = u.node;
    switch ($ = !0, f.type.id) {
      case $i:
        h({
          name: "#",
          type: "hash",
          position: { start: u.from, end: u.to },
          normalizedValue: "#"
        }), $ = !1;
        break;
      case Ie: {
        const c = f.firstChild.nextSibling;
        (c == null ? void 0 : c.type.id) === oi && h(o(c)), $ = !1;
        break;
      }
      case ws:
      case Ts: {
        gi(n(f)).forEach((c) => h(
          a({
            ...c,
            position: {
              start: c.position.start + f.from,
              end: c.position.end + f.from
            }
          })
        )), $ = !1;
        break;
      }
    }
  } while (u.next($));
  return i.forEach(
    (f) => f.forEach((c) => {
      c.error = "missing_close_tag";
    })
  ), s;
};
class Si extends Gs {
  constructor(t, e) {
    super(), this.value = t, this.examplePluralNum = e;
  }
  toDOM() {
    const t = document.createElement("span");
    let e = `placeholder-widget placeholder-${this.value.type}`;
    this.value.error && (e = e + ` placeholder-error placeholder-error-${this.value.error}`), t.className = e;
    const s = document.createElement("span");
    return s.textContent = this.value.type !== "hash" ? this.value.name : `#${this.examplePluralNum ?? ""}`, t.appendChild(s), t;
  }
}
function Me(r, t, e) {
  const s = mi(r, e);
  return s === null ? null : s.filter((i) => {
    if (t) {
      const [n] = t;
      if (n > i.position.start && n < i.position.end)
        return !1;
    }
    return !0;
  });
}
function He(r, t) {
  const e = new Te();
  return r.forEach((s) => {
    e.add(
      s.position.start,
      s.position.end,
      K.widget({
        widget: new Si(s, t),
        side: 1
      })
    );
  }), e.finish();
}
function bi(r, t) {
  return t.find((e) => e.name === r.name && e.type === e.type);
}
function xi(r, t) {
  return t.find(
    (e) => e.name === r.name && e.type === r.type && e.position.start === e.position.start && e.position.end === e.position.end
  );
}
function ki(r, t, e) {
  return t.filter((s) => !!(xi(s, r) || bi(s, e)));
}
function yi(r, t, e, s, i) {
  const n = e - t, l = i - s - n;
  return r.filter((a) => t < a.position.end && e > a.position.start ? !1 : (e < a.position.start && (a.position.start += l, a.position.end += l), !0));
}
function he(r, t) {
  let e = r;
  return t.iterChanges((s, i, n, o) => {
    e = yi(e, s, i, n, o);
  }), e;
}
const pr = (r) => {
  const { noUpdates: t, allowedNewPlaceholders: e, nested: s, tooltips: i } = r;
  return Os.define({
    create(n) {
      try {
        return Me(n.doc.toString(), void 0, s) || [];
      } catch {
        return [];
      }
    },
    update(n, o) {
      if (t)
        return he(n, o.changes);
      if (o.docChanged && !t) {
        let l;
        o.changes.iterChanges((h, u, $, f) => {
          const c = u - h;
          f - $ - c <= 1 && (l = [$, f]);
        });
        const a = Me(
          o.state.doc.toString(),
          l,
          s
        );
        return a === null ? he(n, o.changes) : e ? ki(
          n,
          he(n, o.changes),
          e
        ) : a;
      }
      return n;
    },
    provide(n) {
      const o = [
        Ht.fromClass(
          class {
            constructor(l) {
              Vt(this, "decorationSet");
              this.decorationSet = He(
                l.state.field(n),
                r == null ? void 0 : r.examplePluralNum
              );
            }
            update(l) {
              this.decorationSet = He(
                l.state.field(n),
                r == null ? void 0 : r.examplePluralNum
              );
            }
          },
          {
            decorations: (l) => l.decorationSet,
            provide: (l) => ht.atomicRanges.of((a) => {
              var h;
              return ((h = a.plugin(l)) == null ? void 0 : h.decorationSet) || K.none;
            })
          }
        )
      ];
      return i && o.push(
        As((l, a, h) => {
          const $ = l.state.field(n).find(({ position: f }) => a === f.start && h > 0);
          return $ ? {
            pos: $.position.start,
            end: $.position.end,
            create() {
              const f = document.createElement("div");
              return f.textContent = $.normalizedValue, { dom: f };
            }
          } : null;
        })
      ), o;
    }
  });
};
let Ji = 0;
class Q {
  /**
  @internal
  */
  constructor(t, e, s) {
    this.set = t, this.base = e, this.modified = s, this.id = Ji++;
  }
  /**
  Define a new tag. If `parent` is given, the tag is treated as a
  sub-tag of that parent, and
  [highlighters](#highlight.tagHighlighter) that don't mention
  this tag will try to fall back to the parent tag (or grandparent
  tag, etc).
  */
  static define(t) {
    if (t != null && t.base)
      throw new Error("Can not derive from a modified tag");
    let e = new Q([], null, []);
    if (e.set.push(e), t)
      for (let s of t.set)
        e.set.push(s);
    return e;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier() {
    let t = new Qt();
    return (e) => e.modified.indexOf(t) > -1 ? e : Qt.get(e.base || e, e.modified.concat(t).sort((s, i) => s.id - i.id));
  }
}
let wi = 0;
class Qt {
  constructor() {
    this.instances = [], this.id = wi++;
  }
  static get(t, e) {
    if (!e.length)
      return t;
    let s = e[0].instances.find((l) => l.base == t && Ti(e, l.modified));
    if (s)
      return s;
    let i = [], n = new Q(i, t, e);
    for (let l of e)
      l.instances.push(n);
    let o = Fi(e);
    for (let l of t.set)
      if (!l.modified.length)
        for (let a of o)
          i.push(Qt.get(l, a));
    return n;
  }
}
function Ti(r, t) {
  return r.length == t.length && r.every((e, s) => e == t[s]);
}
function Fi(r) {
  let t = [[]];
  for (let e = 0; e < r.length; e++)
    for (let s = 0, i = t.length; s < i; s++)
      t.push(t[s].concat(r[e]));
  return t.sort((e, s) => s.length - e.length);
}
function Is(r) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let e in r) {
    let s = r[e];
    Array.isArray(s) || (s = [s]);
    for (let i of e.split(" "))
      if (i) {
        let n = [], o = 2, l = i;
        for (let $ = 0; ; ) {
          if (l == "..." && $ > 0 && $ + 3 == i.length) {
            o = 1;
            break;
          }
          let f = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(l);
          if (!f)
            throw new RangeError("Invalid path: " + i);
          if (n.push(f[0] == "*" ? "" : f[0][0] == '"' ? JSON.parse(f[0]) : f[0]), $ += f[0].length, $ == i.length)
            break;
          let c = i[$++];
          if ($ == i.length && c == "!") {
            o = 0;
            break;
          }
          if (c != "/")
            throw new RangeError("Invalid path: " + i);
          l = i.slice($);
        }
        let a = n.length - 1, h = n[a];
        if (!h)
          throw new RangeError("Invalid path: " + i);
        let u = new Kt(s, o, a > 0 ? n.slice(0, a) : null);
        t[h] = u.sort(t[h]);
      }
  }
  return zs.add(t);
}
const zs = new x();
class Kt {
  constructor(t, e, s, i) {
    this.tags = t, this.mode = e, this.context = s, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(t) {
    return !t || t.depth < this.depth ? (this.next = t, this) : (t.next = this.sort(t.next), t);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
Kt.empty = new Kt([], 2, null);
function Ds(r, t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n of r)
    if (!Array.isArray(n.tag))
      e[n.tag.id] = n.class;
    else
      for (let o of n.tag)
        e[o.id] = n.class;
  let { scope: s, all: i = null } = t || {};
  return {
    style: (n) => {
      let o = i;
      for (let l of n)
        for (let a of l.set) {
          let h = e[a.id];
          if (h) {
            o = o ? o + " " + h : h;
            break;
          }
        }
      return o;
    },
    scope: s
  };
}
function Ri(r, t) {
  let e = null;
  for (let s of r) {
    let i = s.style(t);
    i && (e = e ? e + " " + i : i);
  }
  return e;
}
function Vi(r, t, e, s = 0, i = r.length) {
  let n = new vi(s, Array.isArray(t) ? t : [t], e);
  n.highlightRange(r.cursor(), s, i, "", n.highlighters), n.flush(i);
}
class vi {
  constructor(t, e, s) {
    this.at = t, this.highlighters = e, this.span = s, this.class = "";
  }
  startSpan(t, e) {
    e != this.class && (this.flush(t), t > this.at && (this.at = t), this.class = e);
  }
  flush(t) {
    t > this.at && this.class && this.span(this.at, t, this.class);
  }
  highlightRange(t, e, s, i, n) {
    let { type: o, from: l, to: a } = t;
    if (l >= s || a <= e)
      return;
    o.isTop && (n = this.highlighters.filter((c) => !c.scope || c.scope(o)));
    let h = i, u = Ii(t) || Kt.empty, $ = Ri(n, u.tags);
    if ($ && (h && (h += " "), h += $, u.mode == 1 && (i += (i ? " " : "") + $)), this.startSpan(Math.max(e, l), h), u.opaque)
      return;
    let f = t.tree && t.tree.prop(x.mounted);
    if (f && f.overlay) {
      let c = t.node.enter(f.overlay[0].from + l, 1), d = this.highlighters.filter((R) => !R.scope || R.scope(f.tree.type)), m = t.firstChild();
      for (let R = 0, I = l; ; R++) {
        let z = R < f.overlay.length ? f.overlay[R] : null, J = z ? z.from + l : a, N = Math.max(e, I), S = Math.min(s, J);
        if (N < S && m)
          for (; t.from < S && (this.highlightRange(t, N, S, i, n), this.startSpan(Math.min(S, t.to), h), !(t.to >= J || !t.nextSibling())); )
            ;
        if (!z || J > s)
          break;
        I = z.to + l, I > e && (this.highlightRange(c.cursor(), Math.max(e, z.from + l), Math.min(s, I), "", d), this.startSpan(Math.min(s, I), h));
      }
      m && t.parent();
    } else if (t.firstChild()) {
      f && (i = "");
      do
        if (!(t.to <= e)) {
          if (t.from >= s)
            break;
          this.highlightRange(t, e, s, i, n), this.startSpan(Math.min(s, t.to), h);
        }
      while (t.nextSibling());
      t.parent();
    }
  }
}
function Ii(r) {
  let t = r.type.prop(zs);
  for (; t && t.context && !r.matchContext(t.context); )
    t = t.next;
  return t || null;
}
const p = Q.define, Pt = p(), H = p(), ts = p(H), es = p(H), tt = p(), Ct = p(tt), ue = p(tt), Y = p(), lt = p(Y), X = p(), _ = p(), ke = p(), mt = p(ke), qt = p(), U = {
  /**
  A comment.
  */
  comment: Pt,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: p(Pt),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: p(Pt),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: p(Pt),
  /**
  Any kind of identifier.
  */
  name: H,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: p(H),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: ts,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: p(ts),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: es,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: p(es),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: p(H),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: p(H),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: p(H),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: p(H),
  /**
  A literal value.
  */
  literal: tt,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: Ct,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: p(Ct),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: p(Ct),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: p(Ct),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: ue,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: p(ue),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: p(ue),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: p(tt),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: p(tt),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: p(tt),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: p(tt),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: p(tt),
  /**
  A language keyword.
  */
  keyword: X,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: p(X),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: p(X),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: p(X),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: p(X),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: p(X),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: p(X),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: p(X),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: p(X),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: p(X),
  /**
  An operator.
  */
  operator: _,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: p(_),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: p(_),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: p(_),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: p(_),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: p(_),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: p(_),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: p(_),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: p(_),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: p(_),
  /**
  Program or markup punctuation.
  */
  punctuation: ke,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: p(ke),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: mt,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: p(mt),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: p(mt),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: p(mt),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: p(mt),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: Y,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: lt,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: p(lt),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: p(lt),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: p(lt),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: p(lt),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: p(lt),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: p(lt),
  /**
  A prose separator (such as a horizontal rule).
  */
  contentSeparator: p(Y),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: p(Y),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: p(Y),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: p(Y),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: p(Y),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: p(Y),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: p(Y),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: p(Y),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: p(),
  /**
  Deleted text.
  */
  deleted: p(),
  /**
  Changed text.
  */
  changed: p(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: p(),
  /**
  Metadata or meta-instruction.
  */
  meta: qt,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: p(qt),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: p(qt),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: p(qt),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: Q.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: Q.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: Q.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: Q.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: Q.defineModifier(),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: Q.defineModifier()
};
Ds([
  { tag: U.link, class: "tok-link" },
  { tag: U.heading, class: "tok-heading" },
  { tag: U.emphasis, class: "tok-emphasis" },
  { tag: U.strong, class: "tok-strong" },
  { tag: U.keyword, class: "tok-keyword" },
  { tag: U.atom, class: "tok-atom" },
  { tag: U.bool, class: "tok-bool" },
  { tag: U.url, class: "tok-url" },
  { tag: U.labelName, class: "tok-labelName" },
  { tag: U.inserted, class: "tok-inserted" },
  { tag: U.deleted, class: "tok-deleted" },
  { tag: U.literal, class: "tok-literal" },
  { tag: U.string, class: "tok-string" },
  { tag: U.number, class: "tok-number" },
  { tag: [U.regexp, U.escape, U.special(U.string)], class: "tok-string2" },
  { tag: U.variableName, class: "tok-variableName" },
  { tag: U.local(U.variableName), class: "tok-variableName tok-local" },
  { tag: U.definition(U.variableName), class: "tok-variableName tok-definition" },
  { tag: U.special(U.variableName), class: "tok-variableName2" },
  { tag: U.definition(U.propertyName), class: "tok-propertyName tok-definition" },
  { tag: U.typeName, class: "tok-typeName" },
  { tag: U.namespace, class: "tok-namespace" },
  { tag: U.className, class: "tok-className" },
  { tag: U.macroName, class: "tok-macroName" },
  { tag: U.propertyName, class: "tok-propertyName" },
  { tag: U.operator, class: "tok-operator" },
  { tag: U.comment, class: "tok-comment" },
  { tag: U.meta, class: "tok-meta" },
  { tag: U.invalid, class: "tok-invalid" },
  { tag: U.punctuation, class: "tok-punctuation" }
]);
const ye = "ͼ", ss = typeof Symbol > "u" ? "__" + ye : Symbol.for(ye), Je = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), is = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class rs {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(t, e) {
    this.rules = [];
    let { finish: s } = e || {};
    function i(o) {
      return /^@/.test(o) ? [o] : o.split(/,\s*/);
    }
    function n(o, l, a, h) {
      let u = [], $ = /^@(\w+)\b/.exec(o[0]), f = $ && $[1] == "keyframes";
      if ($ && l == null)
        return a.push(o[0] + ";");
      for (let c in l) {
        let d = l[c];
        if (/&/.test(c))
          n(
            c.split(/,\s*/).map((m) => o.map((R) => m.replace(/&/, R))).reduce((m, R) => m.concat(R)),
            d,
            a
          );
        else if (d && typeof d == "object") {
          if (!$)
            throw new RangeError("The value of a property (" + c + ") should be a primitive value.");
          n(i(c), d, u, f);
        } else
          d != null && u.push(c.replace(/_.*/, "").replace(/[A-Z]/g, (m) => "-" + m.toLowerCase()) + ": " + d + ";");
      }
      (u.length || f) && a.push((s && !$ && !h ? o.map(s) : o).join(", ") + " {" + u.join(" ") + "}");
    }
    for (let o in t)
      n(i(o), t[o], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let t = is[ss] || 1;
    return is[ss] = t + 1, ye + t.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(t, e, s) {
    let i = t[Je], n = s && s.nonce;
    i ? n && i.setNonce(n) : i = new zi(t, n), i.mount(Array.isArray(e) ? e : [e]);
  }
}
let ns = /* @__PURE__ */ new Map();
class zi {
  constructor(t, e) {
    let s = t.ownerDocument || t, i = s.defaultView;
    if (!t.head && t.adoptedStyleSheets && i.CSSStyleSheet) {
      let n = ns.get(s);
      if (n)
        return t.adoptedStyleSheets = [n.sheet, ...t.adoptedStyleSheets], t[Je] = n;
      this.sheet = new i.CSSStyleSheet(), t.adoptedStyleSheets = [this.sheet, ...t.adoptedStyleSheets], ns.set(s, this);
    } else {
      this.styleTag = s.createElement("style"), e && this.styleTag.setAttribute("nonce", e);
      let n = t.head || t;
      n.insertBefore(this.styleTag, n.firstChild);
    }
    this.modules = [], t[Je] = this;
  }
  mount(t) {
    let e = this.sheet, s = 0, i = 0;
    for (let n = 0; n < t.length; n++) {
      let o = t[n], l = this.modules.indexOf(o);
      if (l < i && l > -1 && (this.modules.splice(l, 1), i--, l = -1), l == -1) {
        if (this.modules.splice(i++, 0, o), e)
          for (let a = 0; a < o.rules.length; a++)
            e.insertRule(o.rules[a], s++);
      } else {
        for (; i < l; )
          s += this.modules[i++].rules.length;
        s += o.rules.length, i++;
      }
    }
    if (!e) {
      let n = "";
      for (let o = 0; o < this.modules.length; o++)
        n += this.modules[o].getRules() + `
`;
      this.styleTag.textContent = n;
    }
  }
  setNonce(t) {
    this.styleTag && this.styleTag.getAttribute("nonce") != t && this.styleTag.setAttribute("nonce", t);
  }
}
var $e;
const pt = /* @__PURE__ */ new x();
function Di(r) {
  return Mt.define({
    combine: r ? (t) => t.concat(r) : void 0
  });
}
const Wi = /* @__PURE__ */ new x();
class G {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(t, e, s = [], i = "") {
    this.data = t, this.name = i, se.prototype.hasOwnProperty("tree") || Object.defineProperty(se.prototype, "tree", { get() {
      return M(this);
    } }), this.parser = e, this.extension = [
      jt.of(this),
      se.languageData.of((n, o, l) => {
        let a = os(n, o, l), h = a.type.prop(pt);
        if (!h)
          return [];
        let u = n.facet(h), $ = a.type.prop(Wi);
        if ($) {
          let f = a.resolve(o - a.from, l);
          for (let c of $)
            if (c.test(f, n)) {
              let d = n.facet(c.facet);
              return c.type == "replace" ? d : d.concat(u);
            }
        }
        return u;
      })
    ].concat(s);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(t, e, s = -1) {
    return os(t, e, s).type.prop(pt) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(t) {
    let e = t.facet(jt);
    if ((e == null ? void 0 : e.data) == this.data)
      return [{ from: 0, to: t.doc.length }];
    if (!e || !e.allowsNesting)
      return [];
    let s = [], i = (n, o) => {
      if (n.prop(pt) == this.data) {
        s.push({ from: o, to: o + n.length });
        return;
      }
      let l = n.prop(x.mounted);
      if (l) {
        if (l.tree.prop(pt) == this.data) {
          if (l.overlay)
            for (let a of l.overlay)
              s.push({ from: a.from + o, to: a.to + o });
          else
            s.push({ from: o, to: o + n.length });
          return;
        } else if (l.overlay) {
          let a = s.length;
          if (i(l.tree, l.overlay[0].from + o), s.length > a)
            return;
        }
      }
      for (let a = 0; a < n.children.length; a++) {
        let h = n.children[a];
        h instanceof V && i(h, n.positions[a] + o);
      }
    };
    return i(M(t), 0), s;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
G.setState = /* @__PURE__ */ Es.define();
function os(r, t, e) {
  let s = r.facet(jt), i = M(r).topNode;
  if (!s || s.allowsNesting)
    for (let n = i; n; n = n.enter(t, e, v.ExcludeBuffers))
      n.type.isTop && (i = n);
  return i;
}
class Zt extends G {
  constructor(t, e, s) {
    super(t, e, [], s), this.parser = e;
  }
  /**
  Define a language from a parser.
  */
  static define(t) {
    let e = Di(t.languageData);
    return new Zt(e, t.parser.configure({
      props: [pt.add((s) => s.isTop ? e : void 0)]
    }), t.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(t, e) {
    return new Zt(this.data, this.parser.configure(t), e || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function M(r) {
  let t = r.field(G.state, !1);
  return t ? t.tree : V.empty;
}
class Pi {
  /**
  Create an input object for the given document.
  */
  constructor(t) {
    this.doc = t, this.cursorPos = 0, this.string = "", this.cursor = t.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(t) {
    return this.string = this.cursor.next(t - this.cursorPos).value, this.cursorPos = t + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(t) {
    return this.syncTo(t), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(t, e) {
    let s = this.cursorPos - this.string.length;
    return t < s || e >= this.cursorPos ? this.doc.sliceString(t, e) : this.string.slice(t - s, e - s);
  }
}
let St = null;
class Lt {
  constructor(t, e, s = [], i, n, o, l, a) {
    this.parser = t, this.state = e, this.fragments = s, this.tree = i, this.treeLen = n, this.viewport = o, this.skipped = l, this.scheduleOn = a, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(t, e, s) {
    return new Lt(t, e, [], V.empty, 0, s, [], null);
  }
  startParse() {
    return this.parser.startParse(new Pi(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(t, e) {
    return e != null && e >= this.state.doc.length && (e = void 0), this.tree != V.empty && this.isDone(e ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var s;
      if (typeof t == "number") {
        let i = Date.now() + t;
        t = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), e != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > e) && e < this.state.doc.length && this.parse.stopAt(e); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(ut.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (s = this.parse.stoppedAt) !== null && s !== void 0 ? s : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (e ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (t())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let t, e;
    this.parse && (t = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > t) && this.parse.stopAt(t), this.withContext(() => {
      for (; !(e = this.parse.advance()); )
        ;
    }), this.treeLen = t, this.tree = e, this.fragments = this.withoutTempSkipped(ut.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(t) {
    let e = St;
    St = this;
    try {
      return t();
    } finally {
      St = e;
    }
  }
  withoutTempSkipped(t) {
    for (let e; e = this.tempSkipped.pop(); )
      t = ls(t, e.from, e.to);
    return t;
  }
  /**
  @internal
  */
  changes(t, e) {
    let { fragments: s, tree: i, treeLen: n, viewport: o, skipped: l } = this;
    if (this.takeTree(), !t.empty) {
      let a = [];
      if (t.iterChangedRanges((h, u, $, f) => a.push({ fromA: h, toA: u, fromB: $, toB: f })), s = ut.applyChanges(s, a), i = V.empty, n = 0, o = { from: t.mapPos(o.from, -1), to: t.mapPos(o.to, 1) }, this.skipped.length) {
        l = [];
        for (let h of this.skipped) {
          let u = t.mapPos(h.from, 1), $ = t.mapPos(h.to, -1);
          u < $ && l.push({ from: u, to: $ });
        }
      }
    }
    return new Lt(this.parser, e, s, i, n, o, l, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(t) {
    if (this.viewport.from == t.from && this.viewport.to == t.to)
      return !1;
    this.viewport = t;
    let e = this.skipped.length;
    for (let s = 0; s < this.skipped.length; s++) {
      let { from: i, to: n } = this.skipped[s];
      i < t.to && n > t.from && (this.fragments = ls(this.fragments, i, n), this.skipped.splice(s--, 1));
    }
    return this.skipped.length >= e ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(t, e) {
    this.skipped.push({ from: t, to: e });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(t) {
    return new class extends ys {
      createParse(e, s, i) {
        let n = i[0].from, o = i[i.length - 1].to;
        return {
          parsedPos: n,
          advance() {
            let a = St;
            if (a) {
              for (let h of i)
                a.tempSkipped.push(h);
              t && (a.scheduleOn = a.scheduleOn ? Promise.all([a.scheduleOn, t]) : t);
            }
            return this.parsedPos = o, new V(W.none, [], [], o - n);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(t) {
    t = Math.min(t, this.state.doc.length);
    let e = this.fragments;
    return this.treeLen >= t && e.length && e[0].from == 0 && e[0].to >= t;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return St;
  }
}
function ls(r, t, e) {
  return ut.applyChanges(r, [{ fromA: t, toA: e, fromB: t, toB: e }]);
}
class Ut {
  constructor(t) {
    this.context = t, this.tree = t.tree;
  }
  apply(t) {
    if (!t.docChanged && this.tree == this.context.tree)
      return this;
    let e = this.context.changes(t.changes, t.state), s = this.context.treeLen == t.startState.doc.length ? void 0 : Math.max(t.changes.mapPos(this.context.treeLen), e.viewport.to);
    return e.work(20, s) || e.takeTree(), new Ut(e);
  }
  static init(t) {
    let e = Math.min(3e3, t.doc.length), s = Lt.create(t.facet(jt).parser, t, { from: 0, to: e });
    return s.work(20, e) || s.takeTree(), new Ut(s);
  }
}
G.state = /* @__PURE__ */ Os.define({
  create: Ut.init,
  update(r, t) {
    for (let e of t.effects)
      if (e.is(G.setState))
        return e.value;
    return t.startState.facet(jt) != t.state.facet(jt) ? Ut.init(t.state) : r.apply(t);
  }
});
let Ws = (r) => {
  let t = setTimeout(
    () => r(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(t);
};
typeof requestIdleCallback < "u" && (Ws = (r) => {
  let t = -1, e = setTimeout(
    () => {
      t = requestIdleCallback(r, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => t < 0 ? clearTimeout(e) : cancelIdleCallback(t);
});
const fe = typeof navigator < "u" && (!(($e = navigator.scheduling) === null || $e === void 0) && $e.isInputPending) ? () => navigator.scheduling.isInputPending() : null, Ci = /* @__PURE__ */ Ht.fromClass(class {
  constructor(t) {
    this.view = t, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(t) {
    let e = this.view.state.field(G.state).context;
    (e.updateViewport(t.view.viewport) || this.view.viewport.to > e.treeLen) && this.scheduleWork(), (t.docChanged || t.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(e);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: t } = this.view, e = t.field(G.state);
    (e.tree != e.context.tree || !e.context.isDone(t.doc.length)) && (this.working = Ws(this.work));
  }
  work(t) {
    this.working = null;
    let e = Date.now();
    if (this.chunkEnd < e && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = e + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: s, viewport: { to: i } } = this.view, n = s.field(G.state);
    if (n.tree == n.context.tree && n.context.isDone(
      i + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let o = Date.now() + Math.min(this.chunkBudget, 100, t && !fe ? Math.max(25, t.timeRemaining() - 5) : 1e9), l = n.context.treeLen < i && s.doc.length > i + 1e3, a = n.context.work(() => fe && fe() || Date.now() > o, i + (l ? 0 : 1e5));
    this.chunkBudget -= Date.now() - e, (a || this.chunkBudget <= 0) && (n.context.takeTree(), this.view.dispatch({ effects: G.setState.of(new Ut(n.context)) })), this.chunkBudget > 0 && !(a && !l) && this.scheduleWork(), this.checkAsyncSchedule(n.context);
  }
  checkAsyncSchedule(t) {
    t.scheduleOn && (this.workScheduled++, t.scheduleOn.then(() => this.scheduleWork()).catch((e) => Ns(this.view.state, e)).then(() => this.workScheduled--), t.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), jt = /* @__PURE__ */ Mt.define({
  combine(r) {
    return r.length ? r[0] : null;
  },
  enables: (r) => [
    G.state,
    Ci,
    ht.contentAttributes.compute([r], (t) => {
      let e = t.facet(r);
      return e && e.name ? { "data-language": e.name } : {};
    })
  ]
});
class qi {
  /**
  Create a language support object.
  */
  constructor(t, e = []) {
    this.language = t, this.support = e, this.extension = [t, e];
  }
}
class ee {
  constructor(t, e) {
    this.specs = t;
    let s;
    function i(l) {
      let a = rs.newName();
      return (s || (s = /* @__PURE__ */ Object.create(null)))["." + a] = l, a;
    }
    const n = typeof e.all == "string" ? e.all : e.all ? i(e.all) : void 0, o = e.scope;
    this.scope = o instanceof G ? (l) => l.prop(pt) == o.data : o ? (l) => l == o : void 0, this.style = Ds(t.map((l) => ({
      tag: l.tag,
      class: l.class || i(Object.assign({}, l, { tag: null }))
    })), {
      all: n
    }).style, this.module = s ? new rs(s) : null, this.themeType = e.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(t, e) {
    return new ee(t, e || {});
  }
}
const we = /* @__PURE__ */ Mt.define(), Ps = /* @__PURE__ */ Mt.define({
  combine(r) {
    return r.length ? [r[0]] : null;
  }
});
function ce(r) {
  let t = r.facet(we);
  return t.length ? t : r.facet(Ps);
}
function Ei(r, t) {
  let e = [Gi], s;
  return r instanceof ee && (r.module && e.push(ht.styleModule.of(r.module)), s = r.themeType), t != null && t.fallback ? e.push(Ps.of(r)) : s ? e.push(we.computeN([ht.darkTheme], (i) => i.facet(ht.darkTheme) == (s == "dark") ? [r] : [])) : e.push(we.of(r)), e;
}
class Ai {
  constructor(t) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = M(t.state), this.decorations = this.buildDeco(t, ce(t.state));
  }
  update(t) {
    let e = M(t.state), s = ce(t.state), i = s != ce(t.startState);
    e.length < t.view.viewport.to && !i && e.type == this.tree.type ? this.decorations = this.decorations.map(t.changes) : (e != this.tree || t.viewportChanged || i) && (this.tree = e, this.decorations = this.buildDeco(t.view, s));
  }
  buildDeco(t, e) {
    if (!e || !this.tree.length)
      return K.none;
    let s = new Te();
    for (let { from: i, to: n } of t.visibleRanges)
      Vi(this.tree, e, (o, l, a) => {
        s.add(o, l, this.markCache[a] || (this.markCache[a] = K.mark({ class: a })));
      }, i, n);
    return s.finish();
  }
}
const Gi = /* @__PURE__ */ ms.high(/* @__PURE__ */ Ht.fromClass(Ai, {
  decorations: (r) => r.decorations
})), Ni = /* @__PURE__ */ Object.create(null), as = [W.none], hs = [], us = /* @__PURE__ */ Object.create(null), Bi = /* @__PURE__ */ Object.create(null);
for (let [r, t] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  Bi[r] = /* @__PURE__ */ Xi(Ni, t);
function pe(r, t) {
  hs.indexOf(r) > -1 || (hs.push(r), console.warn(t));
}
function Xi(r, t) {
  let e = [];
  for (let l of t.split(" ")) {
    let a = [];
    for (let h of l.split(".")) {
      let u = r[h] || U[h];
      u ? typeof u == "function" ? a.length ? a = a.map(u) : pe(h, `Modifier ${h} used at start of tag`) : a.length ? pe(h, `Tag ${h} used as modifier`) : a = Array.isArray(u) ? u : [u] : pe(h, `Unknown highlighting tag ${h}`);
    }
    for (let h of a)
      e.push(h);
  }
  if (!e.length)
    return 0;
  let s = t.replace(/ /g, "_"), i = s + " " + e.map((l) => l.id), n = us[i];
  if (n)
    return n.id;
  let o = us[i] = W.define({
    id: as.length,
    name: s,
    props: [Is({ [s]: e })]
  });
  return as.push(o), o.id;
}
Nt.RTL, Nt.LTR;
const _i = (r) => Zt.define({
  name: "icu-tolgee",
  parser: Ft.configure({
    top: r ? "Nested" : "Root",
    props: [
      Is({
        TextRoot: U.string,
        Text: U.string,
        PluralPlaceholder: U.keyword,
        VariantDescriptor: U.keyword,
        FormatFunction: U.keyword,
        SelectFunction: U.keyword,
        Param: U.variableName,
        FormatStyle: U.variableName,
        "{ }": U.paren,
        Sep: U.separator,
        "< >": U.tagName,
        Slash: U.tagName,
        TagName: U.tagName
      })
    ]
  })
});
function Ur(r) {
  return new qi(_i(r));
}
const jr = (r) => Ei(
  ee.define([
    { tag: U.variableName, color: r.other },
    { tag: U.keyword, color: r.function },
    { tag: U.bracket, color: r.other },
    { tag: U.tagName, color: r.other },
    { tag: U.content, color: r.main },
    { tag: U.string, color: r.main }
  ])
), gr = Ht.fromClass(
  class {
    constructor(r) {
      Vt(this, "isolates");
      Vt(this, "tree");
      this.isolates = $s(r), this.tree = M(r.state);
    }
    update(r) {
      (r.docChanged || r.viewportChanged || M(r.state) != this.tree) && (this.isolates = $s(r.view), this.tree = M(r.state));
    }
  },
  {
    provide: (r) => {
      function t(e) {
        var s;
        return ((s = e.plugin(r)) == null ? void 0 : s.isolates) ?? K.none;
      }
      return ms.lowest([
        ht.decorations.of(t),
        ht.bidiIsolatedRanges.of(t)
      ]);
    }
  }
), Yi = K.mark({
  attributes: { style: "direction: ltr; unicode-bidi: isolate" },
  bidiIsolate: Nt.LTR
}), Qi = K.mark({
  attributes: { style: "direction: rtl; unicode-bidi: isolate" },
  bidiIsolate: Nt.RTL
});
function $s(r) {
  const t = new Te();
  for (const { from: e, to: s } of r.visibleRanges)
    M(r.state).iterate({
      from: e,
      to: s,
      enter(i) {
        (i.name === "HtmlTagOpen" || i.name === "HtmlTagClose" || i.name === "Expression") && t.add(i.from, i.to, Yi), (i.name === "TextRoot" || i.name === "Text") && t.add(i.from, i.to, Qi);
      }
    });
  return t.finish();
}
const Ki = {
  variable: {
    border: "#7AD3C1",
    background: "#BEF3E9",
    text: "#008371"
  },
  tag: {
    border: "#F27FA6",
    background: "#F9C4D6",
    text: "#822343"
  },
  variant: {
    border: "#BBC2CB",
    background: "#F0F2F4",
    text: "#4D5B6E"
  }
}, Or = ({
  styled: r,
  colors: t = Ki,
  component: e = "div"
}) => r(e)`
    white-space: pre-wrap;
    & .placeholder-widget {
      display: inline-flex;
      vertical-align: text-top;
      align-items: center;
      justify-content: center;
      min-width: 15px;
      border: 1px solid ${t.variable.border};
      background-color: ${t.variable.background};
      color: ${t.variable.text};
      border-radius: 10px;
      padding: 0px 7px;
      font-size: 12px;
      user-select: none;
      margin: 0px 1px;
      overflow: hidden;

      & > * {
        display: grid;
      }
    }
    & .placeholder-error {
      background: #ff000054;
    }

    & .placeholder-tagOpen {
      border: 1px solid ${t.tag.border};
      background-color: ${t.tag.background};
      color: ${t.tag.text};
      border-radius: 10px 0px 0px 10px;
      padding-right: 6px;
    }

    & .placeholder-tagClose {
      border: 1px solid ${t.tag.border};
      background-color: ${t.tag.background};
      color: ${t.tag.text};
      border-radius: 0px 10px 10px 0px;
      padding-left: 6px;
    }

    & .placeholder-tagSelfClosed {
      border: 1px solid ${t.tag.border};
      background-color: ${t.tag.background};
      color: ${t.tag.text};
    }

    // in rtl mode, revert the placeholders direction
    &[dir="rtl"] .placeholder-tagOpen {
      border-radius: 0px 10px 10px 0px;
      padding-left: 6px;
    }
    &[dir="rtl"] .placeholder-tagClose {
      border-radius: 10px 0px 0px 10px;
      padding-right: 6px;
    }
  `, Zi = (r) => /^[^\p{White_Space}\p{Pattern_Syntax}]*$/uy.test(r), bt = 0, de = 1, Et = 2, Ue = /* @__PURE__ */ new Set(["{", "}", "#"]), q = "'", Li = (r) => {
  let t = bt;
  const e = [];
  for (const s of r)
    switch (t) {
      case bt:
        s === q ? (e.push(s), t = de) : Ue.has(s) ? (e.push(q), e.push(s), t = Et) : e.push(s);
        break;
      case de:
        Ue.has(s) ? (e.push(q), e.push(q), e.push(s), t = Et) : s === q ? (e.push(q), e.push(s), e.push(q), t = bt) : (e.push(s), t = bt);
        break;
      case Et:
        Ue.has(s) ? e.push(s) : s === q ? (e.push(q), e.push(q)) : (e.push(q), e.push(s), t = bt);
    }
  return [de, Et].includes(t) && e.push(q), e.join("");
}, xt = 0, kt = 1, je = 2, ge = 3, fs = 4, cs = 5, ps = /* @__PURE__ */ new Set(["{", "}", "#"]), ds = /* @__PURE__ */ new Set(["{", "}"]), A = "'", Mi = (r) => {
  let t = xt;
  const e = [];
  let s;
  for (const i of r)
    switch (t) {
      case xt:
        i === A ? t = je : ds.has(i) && (e.push(A), s = e.length, t = ge), e.push(i);
        break;
      case je:
        ps.has(i) ? (s = e.length, t = kt) : t = xt, e.push(i);
        break;
      case kt:
        i === A ? t = fs : ps.has(i) && (s = e.length), e.push(i);
        break;
      case fs:
        i === A ? (t = kt, e.push(A)) : (e.push(i), t = xt);
        break;
      case ge:
        i === A ? t = cs : ds.has(i) && (s = e.length), e.push(i);
        break;
      case cs:
        i === A ? (t = kt, e.push(A)) : (e.splice(s + 1, 0, A), e.push(i), t = xt);
        break;
    }
  return [kt, ge].includes(t) ? e.splice(s + 1, 0, A) : t === je && e.push(A), e.join("");
};
function Hi(r) {
  return Ft.configure({ strict: !0 }).parse(r);
}
const mr = (r, t) => {
  const { parameter: e, variants: s } = r;
  if (!e)
    return s.other ?? "";
  if (!Zi(e))
    throw new Error(`Parameter name "${e}" is invalid`);
  const i = [`{${e}, plural,`];
  s.other || (s.other = "");
  let n = !0;
  for (const [o, l] of Object.entries(s)) {
    const a = l || "";
    if (n && a && (n = !1), t)
      i.push(` ${o} {${Li(a)}}`);
    else
      try {
        Hi(`{${e}, plural, other {${a}}}`), i.push(` ${o} {${a}}`);
      } catch {
        i.push(` ${o} {${Mi(a)}}`);
      }
  }
  return n ? "" : (i.push("}"), i.join(""));
}, yt = 0, Oe = 1, me = 2, Us = 3, tr = /* @__PURE__ */ new Set(["{", "}", "#"]), at = "'", er = (r) => {
  let t = yt;
  const e = [];
  for (const s of r)
    switch (t) {
      case yt:
        s === at ? t = Oe : e.push(s);
        break;
      case Oe:
        tr.has(s) ? t = me : (s === at || e.push(at), t = yt), e.push(s);
        break;
      case me:
        s === at ? t = Us : e.push(s);
        break;
      case Us:
        s === at ? (t = me, e.push(at)) : (e.push(s), t = yt);
    }
  return t === Oe && e.push(at), e.join("");
}, js = {
  0: Ie,
  4: te,
  5: ze,
  // this also excludes 'offset:x'
  6: Fs
};
function wt(r, t) {
  return t.substring(r.from, r.to);
}
function sr(r, t, e) {
  let s = r.firstChild;
  do
    if ((s == null ? void 0 : s.type.id) === ui)
      return e ? er(wt(s, t)) : wt(s, t);
  while (s = s == null ? void 0 : s.nextSibling);
  return "";
}
function Jt(r) {
  return { variants: { other: r } };
}
const ir = (r, t) => {
  let e;
  try {
    e = Ft.configure({ strict: !0 }).parse(r);
  } catch {
    return Jt(r);
  }
  const s = e.cursor(), i = {}, n = {}, o = Object.keys(js), l = Number(o[o.length - 1]);
  for (let h = 0; h <= l; h++) {
    s.next();
    const u = s.node, $ = js[h];
    if ($ !== void 0)
      if ($ === u.type.id)
        i[u.type.id] = u;
      else
        return Jt(r);
  }
  if (i[Ie].nextSibling || wt(i[ze], r) !== "plural")
    return Jt(r);
  let a = i[Fs];
  do {
    const h = wt(a.firstChild, r), u = sr(a, r, t);
    if (n[h] !== void 0)
      return Jt(r);
    n[h] = u;
  } while (a = a.nextSibling);
  return {
    parameter: wt(i[te], r),
    variants: n
  };
}, Sr = (r, t, e) => t ? ir(r || "", e) : { variants: { other: r } };
function gs(r) {
  const t = [];
  let e = r.firstChild;
  for (; e; )
    t.push(e), e = e.nextSibling;
  return t;
}
const br = (r) => {
  let t;
  try {
    t = Ft.configure({ strict: !0 }).parse(r);
  } catch {
    return;
  }
  function e(l) {
    return r.substring(l.from, l.to);
  }
  function s(l) {
    const a = gs(l).find(
      (h) => h.type.id === ze
    );
    return a ? e(a) : void 0;
  }
  function i(l) {
    const a = gs(l).find((h) => h.type.id === te);
    return a ? e(a) : void 0;
  }
  const n = t.cursor();
  let o = !1;
  do {
    const l = n.node;
    switch (l.type.id) {
      case hi: {
        if (s(l) === "plural")
          return i(l);
        o = !1;
        break;
      }
      default:
        o = !0;
        break;
    }
  } while (n.next(o));
}, rr = [
  "zero",
  "one",
  "two",
  "few",
  "many",
  "other"
], nr = (r) => {
  try {
    return new Intl.PluralRules(r).resolvedOptions().pluralCategories;
  } catch {
    return rr;
  }
}, or = (r, t) => {
  try {
    return new Intl.PluralRules(r).select(t);
  } catch {
    return "other";
  }
}, lr = [6, 7, 8, 11, 20, 21, 1e6, 0.5, 0.1, 0], ar = [0, 2, 3, 4, 6], hr = [10, 11, 20, 100, 0, 0, 0.1, 2, 3, 4], ur = [
  "zero",
  "one",
  "two",
  "few",
  "many",
  "other"
], xr = (r) => {
  const t = new Set(nr(r));
  return ur.filter((e) => t.has(e));
}, ct = (r, t, e) => e.find((s) => or(t, s) === r), kr = (r, t) => {
  switch (t) {
    case "zero":
      return ct("zero", r, [0]);
    case "one":
      return ct("one", r, [1]);
    case "two":
      return ct("two", r, [2]);
    case "few":
      return ct("few", r, ar);
    case "many":
      return ct("many", r, lr);
    case "other":
      return ct("other", r, hr);
  }
  const e = Number(t.substring(1));
  return Number.isNaN(e) ? void 0 : e;
}, yr = (r) => {
  const t = [
    "ar",
    "arc",
    "dv",
    "fa",
    "ha",
    "he",
    "khw",
    "ks",
    "ku",
    "ps",
    "ur",
    "yi"
  ], e = r.replace(/^([a-zA-Z]+)(.*?)$/, "$1");
  return t.indexOf(e) > -1 ? "rtl" : "ltr";
};
export {
  pr as PlaceholderPlugin,
  jr as TolgeeHighlight,
  Zi as checkParamNameIsValid,
  Or as generatePlaceholdersStyle,
  br as getFirstPluralParameter,
  yr as getLanguageDirection,
  mi as getPlaceholders,
  nr as getPluralRules,
  xr as getPluralVariants,
  Sr as getTolgeeFormat,
  ir as getTolgeePlurals,
  kr as getVariantExample,
  gr as htmlIsolatesPlugin,
  or as selectPluralRule,
  mr as tolgeeFormatGenerateIcu,
  Ft as tolgeeParser,
  Ur as tolgeeSyntax
};
